import { api } from './base-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AssetHistory: { input: any; output: any; }
  AssetMetadata: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Json: { input: any; output: any; }
  QueryParams: { input: any; output: any; }
  Url: { input: any; output: any; }
};

export enum AccessLevel {
  Free = 'FREE',
  Login = 'LOGIN',
  Plus = 'PLUS',
  Premium = 'PREMIUM',
  Sport = 'SPORT',
  Total = 'TOTAL'
}

export type ArchiveInput = {
  __typename?: 'ArchiveInput';
  enabled: Scalars['Boolean']['output'];
};

export type Asset = {
  __typename?: 'Asset';
  additional: AssetAdditional;
  category: Category;
  description?: Maybe<Scalars['String']['output']>;
  flightTimes: FlightTimes;
  id: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  streamUrls: StreamUrls;
  title: Scalars['String']['output'];
};

export type AssetAdditional = {
  __typename?: 'AssetAdditional';
  metadata?: Maybe<Scalars['AssetMetadata']['output']>;
};

export type AssetCriteria = {
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type AssetIdProvider = {
  __typename?: 'AssetIdProvider';
  id: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
};

/** Common interface for all asset ingest states */
export type AssetIngest = {
  /** ID of the asset */
  assetId?: Maybe<Scalars['Int']['output']>;
  /** Provider of the asset */
  provider?: Maybe<Scalars['String']['output']>;
  /** The type of asset ingest */
  type?: Maybe<AssetIngestType>;
};

/** Asset ingest was done successfully */
export type AssetIngestDone = AssetIngest & {
  __typename?: 'AssetIngestDone';
  /** ID of the asset */
  assetId?: Maybe<Scalars['Int']['output']>;
  /** Provider of the asset */
  provider?: Maybe<Scalars['String']['output']>;
  /** The type of asset ingest */
  type?: Maybe<AssetIngestType>;
};

/** Asset ingest failed */
export type AssetIngestFailed = AssetIngest & {
  __typename?: 'AssetIngestFailed';
  /** ID of the asset */
  assetId?: Maybe<Scalars['Int']['output']>;
  /** Provider of the asset */
  provider?: Maybe<Scalars['String']['output']>;
  /** The type of asset ingest */
  type?: Maybe<AssetIngestType>;
};

/** Asset ingest is in progress */
export type AssetIngestInProgress = AssetIngest & {
  __typename?: 'AssetIngestInProgress';
  /** ID of the asset */
  assetId?: Maybe<Scalars['Int']['output']>;
  /** Provider of the asset */
  provider?: Maybe<Scalars['String']['output']>;
  /** Current progress of the asset ingest */
  totalProgress?: Maybe<Scalars['Int']['output']>;
  /** The type of asset ingest */
  type?: Maybe<AssetIngestType>;
};

/** Asset ingest was never done */
export type AssetIngestNone = {
  __typename?: 'AssetIngestNone';
  /** ID of the asset */
  assetId?: Maybe<Scalars['Int']['output']>;
  /** Provider of the asset */
  provider?: Maybe<Scalars['String']['output']>;
};

/** The type of the asset ingest */
export enum AssetIngestType {
  /** Ingest is cutting asset */
  Cutting = 'CUTTING',
  /** Ingest is transcoding asset */
  Transcoding = 'TRANSCODING'
}

export type AssetPodmeMetadata = {
  __typename?: 'AssetPodmeMetadata';
  /** Episode ID in Podme that asset is connected with */
  podmeId?: Maybe<Scalars['Int']['output']>;
  /** Whether or not asset should be connected to Podme */
  sendToPodme: Scalars['Boolean']['output'];
};

/** Metadata to modify (provide only the fields you want to set or remove, to remove provide null/false value) */
export type AssetPodmeMetadataInput = {
  podmeId?: InputMaybe<Scalars['Int']['input']>;
  sendToPodme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetPodmeWhereInput = {
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type AssetSchedule = {
  __typename?: 'AssetSchedule';
  action: AssetScheduleActions;
  assetId: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  /** Unix Timestamp (seconds) */
  time: Scalars['Int']['output'];
};

export enum AssetScheduleActions {
  Publish = 'PUBLISH',
  Unpublish = 'UNPUBLISH'
}

export type AssetScheduleCreateInput = {
  action: AssetScheduleActions;
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  time: Scalars['Int']['input'];
};

export type AssetScheduleInput = {
  /** Unix timestamp when the asset should be playable */
  startTime: Scalars['Int']['input'];
};

export type AssetScheduleUpdateInput = {
  time: Scalars['Int']['input'];
};

/** Filtering is done with the AND logical operator. */
export type AssetScheduleWhereUniqueInput = {
  /** action is an exact match */
  action: AssetScheduleActions;
  /** assetId is an exact match */
  assetId: Scalars['Int']['input'];
  /** provider is an exact match, case sensitive filtering */
  provider: Scalars['String']['input'];
};

/** Filtering is done with the AND logical operator. */
export type AssetSchedulesWhereInput = {
  /** action is an exact match */
  action?: InputMaybe<AssetScheduleActions>;
  /** assetId is an exact match */
  assetId?: InputMaybe<Scalars['Int']['input']>;
  /** provider is an exact match, case sensitive filtering */
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type AudioChannelsMix = {
  stereoMix?: InputMaybe<StereoMix>;
};

export type Author = {
  __typename?: 'Author';
  contact?: Maybe<Array<ContactEntry>>;
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CancelAdInput = {
  /** Id of an asset to insert the ad into */
  assetId: Scalars['Int']['input'];
  /** Newsroom */
  newsroom: Scalars['String']['input'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['Int']['output'];
};

export type CategoryPodmeMetadata = {
  __typename?: 'CategoryPodmeMetadata';
  /** List of podcast categories */
  podmeCategories: Array<Scalars['Int']['output']>;
  /** Podcast ID in Podme that category is connected with */
  podmeId?: Maybe<Scalars['Int']['output']>;
  /** Whether or not podcast RSS link should be send to Podme */
  sendRssToPodme: Scalars['Boolean']['output'];
  /** Whether or not category should be connected to Podme */
  sendToPodme: Scalars['Boolean']['output'];
};

/** Metadata to modify (provide only the fields you want to set or remove, to remove provide null/false value) */
export type CategoryPodmeMetadataInput = {
  podmeCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  podmeId?: InputMaybe<Scalars['Int']['input']>;
  sendRssToPodme?: InputMaybe<Scalars['Boolean']['input']>;
  sendToPodme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPodmeWhereInput = {
  categoryId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type ChangeAssetRestrictionsInput = {
  /** Provider level of asset protection */
  accessLevel?: InputMaybe<AccessLevel>;
  /** SVP asset id */
  assetId: Scalars['Int']['input'];
  /** Name of the country to apply the geoblock */
  geoRestriction?: InputMaybe<GeoRestriction>;
  /** SVP provider */
  provider: Scalars['String']['input'];
};

export type ContactEntry = {
  __typename?: 'ContactEntry';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ControlLiveStreamInput = {
  assetId: Scalars['Int']['input'];
  /** User name or email. */
  editedBy?: InputMaybe<Scalars['String']['input']>;
  newsroom: Scalars['String']['input'];
};

export type ConvertVideoInput = {
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** Provider ID */
  provider: Scalars['String']['input'];
};

export type ConvertVideoOutput = {
  __typename?: 'ConvertVideoOutput';
  /** Converted video URL */
  url: Scalars['String']['output'];
};

export type CreateClipsInput = {
  assetId: Scalars['Int']['input'];
  cutRanges: Array<WeakCutRange>;
  protection?: InputMaybe<Protections>;
  provider: Scalars['String']['input'];
};

export type CreateClipsResponse = CreateClipsSuccessResponse | ErrorResponse;

export type CreateClipsSuccessResponse = {
  __typename?: 'CreateClipsSuccessResponse';
  assetId: Scalars['Int']['output'];
  originAssetId: Scalars['Int']['output'];
};

export type CreateLiveStreamInput = {
  audioNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
  deinterlace?: InputMaybe<Scalars['Boolean']['input']>;
  liveArchive?: InputMaybe<Scalars['Boolean']['input']>;
  livePreview?: InputMaybe<Scalars['Boolean']['input']>;
  metadata: CreateLiveStreamMetadataInput;
  newsroom: Scalars['String']['input'];
  overlay?: InputMaybe<LiveStreamOverlayInput>;
  schedule?: InputMaybe<LiveStreamScheduleInput>;
  setup: LiveStreamSetupInput;
  vertical?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Basic stream metadata to be saved during creation. */
export type CreateLiveStreamMetadataInput = {
  /** Asset access. Should be used in conjunction with LiveStreamProtection of HLSStreamInput */
  access?: InputMaybe<Scalars['String']['input']>;
  /** Category in which asset will be created. */
  categoryId: Scalars['Int']['input'];
  /** User name or email. Should be set when setting metadata first time. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Description of the asset. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Title of the asset. */
  title: Scalars['String']['input'];
};

export type CreateLiveStreamOutput = {
  __typename?: 'CreateLiveStreamOutput';
  asset: Asset;
  events: Array<LiveEvent>;
};

export type CreatePlaylistInput = {
  header?: InputMaybe<Scalars['String']['input']>;
  items?: Array<PlaylistItemInput>;
  labels?: InputMaybe<Array<PlaylistLabelInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlaylistResponse = {
  __typename?: 'CreatePlaylistResponse';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  playlist?: Maybe<StreamPlaylist>;
  success: Scalars['Boolean']['output'];
};

export type CreatePodmeEpisodeInput = {
  audioHlsUrl: Scalars['String']['input'];
  audioMp3Url: Scalars['String']['input'];
  description: Scalars['String']['input'];
  episodeLength: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isPremium: Scalars['Boolean']['input'];
  podcastId: Scalars['Int']['input'];
  publishDate: Scalars['DateTime']['input'];
  rssId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePodmeEpisodeResult = {
  __typename?: 'CreatePodmeEpisodeResult';
  id: Scalars['Int']['output'];
};

export type CreatePodmePodcastInput = {
  authorName: Scalars['String']['input'];
  categoryIds: Array<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  rssFeedLink?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePodmePodcastResult = {
  __typename?: 'CreatePodmePodcastResult';
  id: Scalars['Int']['output'];
};

export type CreateRtmpPushInput = {
  metadata: CreateLiveStreamMetadataInput;
  newsroom: Scalars['String']['input'];
  streamKey: Scalars['String']['input'];
  streamType: RtmpStreamTypeInput;
};

export type CreateRtmpPushOutput = {
  __typename?: 'CreateRtmpPushOutput';
  asset: Asset;
};

export type CreateTrimInput = {
  assetId: Scalars['Int']['input'];
  cutRanges: Array<WeakCutRange>;
  provider: Scalars['String']['input'];
};

export type CreateUserInput = {
  created: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  roles: Array<RoleInput>;
};

export type CropLiveArchiveInput = {
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** User name or email */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Adjust start time and end time of live archive */
  cutRange: LiveArchiveCutRangeInput;
  /** Provider ID */
  provider: Scalars['String']['input'];
};

export type CropLiveArchiveOutput = {
  __typename?: 'CropLiveArchiveOutput';
  /** Newly created asset with cropped live archive */
  assetId?: Maybe<Scalars['Int']['output']>;
  /** Id of an origin asset */
  originAssetId?: Maybe<Scalars['Int']['output']>;
};

export type CutRange = {
  begin: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
};

export type CuttingroomChannel = {
  __typename?: 'CuttingroomChannel';
  name: Scalars['String']['output'];
  server: Scalars['String']['output'];
  streamKey: Scalars['String']['output'];
};

export type DeletePlaylistInput = {
  id: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type DeletePlaylistResponse = {
  __typename?: 'DeletePlaylistResponse';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  playlist?: Maybe<StreamPlaylist>;
  success: Scalars['Boolean']['output'];
};

export type DeletePodmeEpisodeInput = {
  id: Scalars['Int']['input'];
};

export type DeletePodmePodcastInput = {
  id: Scalars['Int']['input'];
};

export type DuplicateLiveStreamInput = {
  assetId: Scalars['Int']['input'];
  duplicatedBy: Scalars['String']['input'];
  newsroom: Scalars['String']['input'];
};

export type DuplicateLiveStreamOutput = {
  __typename?: 'DuplicateLiveStreamOutput';
  asset: Asset;
};

export type ElementalEvent = ElementalNetworkEvent | ElementalSdiEvent;

export type ElementalInput = {
  __typename?: 'ElementalInput';
  description?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  event?: Maybe<LiveEvent>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ElementalLive = Live & ScheduledLive & {
  __typename?: 'ElementalLive';
  asset: Asset;
  events: Array<ElementalEvent>;
  schedule: Schedule;
};

export type ElementalLiveEncoder = {
  __typename?: 'ElementalLiveEncoder';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ElementalLiveEvent = {
  dvrLength?: Maybe<Scalars['Int']['output']>;
  encoder: ElementalLiveEncoder;
  hasLivePreview: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  input: ElementalLiveInput;
  name: Scalars['String']['output'];
  status: LiveEventStatus;
  type: ElementalLiveEventType;
};

export enum ElementalLiveEventType {
  Backup = 'BACKUP',
  Primary = 'PRIMARY'
}

export type ElementalLiveInput = {
  __typename?: 'ElementalLiveInput';
  description?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ElementalNetworkEvent = ElementalLiveEvent & {
  __typename?: 'ElementalNetworkEvent';
  dvrLength?: Maybe<Scalars['Int']['output']>;
  encoder: ElementalLiveEncoder;
  hasLivePreview: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  input: ElementalLiveInput;
  name: Scalars['String']['output'];
  networkInputUri: Scalars['String']['output'];
  status: LiveEventStatus;
  type: ElementalLiveEventType;
};

export type ElementalSdiEvent = ElementalLiveEvent & {
  __typename?: 'ElementalSdiEvent';
  dvrLength?: Maybe<Scalars['Int']['output']>;
  encoder: ElementalLiveEncoder;
  hasLivePreview: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  input: ElementalLiveInput;
  name: Scalars['String']['output'];
  status: LiveEventStatus;
  type: ElementalLiveEventType;
};

export type EncoderInputPreview = {
  __typename?: 'EncoderInputPreview';
  base64: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type EncoderInputPreviewInput = {
  sdi: SdiSourceInput;
  size: EncoderInputPreviewSizeInput;
};

export type EncoderInputPreviewSizeInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type EncoderParamsInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  /** SVP newsroom */
  newsroom: Scalars['String']['input'];
  /** Stream protections to apply */
  protections?: Array<StreamProtection>;
  streamKey: Scalars['String']['input'];
  type: EncoderType;
};

export type EncoderParamsWhere = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Media type */
  mediaType?: InputMaybe<MediaType>;
};

export type EncoderScheduleInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Unix timestamp when the encoder should be automatically started */
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export enum EncoderType {
  Backup = 'BACKUP',
  Primary = 'PRIMARY'
}

export enum EncodingProfile {
  Fast = 'FAST',
  Hq = 'HQ',
  Normal = 'NORMAL'
}

export enum EntryPointType {
  Backup = 'BACKUP',
  Primary = 'PRIMARY'
}

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  message: Scalars['String']['output'];
};

export type ExternalLive = Live & {
  __typename?: 'ExternalLive';
  asset: Asset;
  externalUrl: Scalars['String']['output'];
};

export type ExternalSourceInput = {
  url: Scalars['String']['input'];
};

export type FilterInput = {
  /** id is an exact match, case sensitive filtering */
  id?: InputMaybe<Scalars['String']['input']>;
  /** case sensitive, exact match on label.id. If multiple labels are provided, operator `AND` is between them */
  labels?: Array<Scalars['String']['input']>;
  /** name supports case insensitive full text search filtering */
  name?: InputMaybe<Scalars['String']['input']>;
  /** provider is an exact match, case sensitive filtering */
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type FlightTimes = {
  __typename?: 'FlightTimes';
  start: Scalars['Int']['output'];
};

export type GenerateAkamaiTokenInput = {
  /** SVP access from access definition endpoint */
  access: Scalars['String']['input'];
  /** SVP asset id */
  assetId: Scalars['Int']['input'];
  /** Token lifetime in seconds */
  expirationTime: Scalars['Int']['input'];
  /** SVP provider */
  provider: Scalars['String']['input'];
};

export type GenerateAkamaiTokenOutput = {
  __typename?: 'GenerateAkamaiTokenOutput';
  /** Akamai access token */
  token: Scalars['String']['output'];
};

export type GenerateAkamaiUrlInput = {
  /** Name of the file */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** SVP newsroom */
  newsroom: Scalars['String']['input'];
  /** Full path to the file */
  path: Scalars['String']['input'];
  /** Stream protection to apply */
  protection?: InputMaybe<GenerateAkamaiUrlProtectionInput>;
  /** Stream protections to apply */
  protections?: InputMaybe<GenerateStreamUrlProtectionsInput>;
};

export type GenerateAkamaiUrlOutput = {
  __typename?: 'GenerateAkamaiUrlOutput';
  /** Url for adaptive media streaming format */
  adaptiveMediaDelivery: Scalars['Url']['output'];
  /** Url for serving media files */
  downloadDelivery: Scalars['Url']['output'];
  /** Url to use with Net Storage API */
  netStorage: Scalars['Url']['output'];
  /** Url for serving files that support HTTP progressive download */
  pseudoStreaming: Scalars['Url']['output'];
};

export type GenerateAkamaiUrlProtectionInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  geoRestriction?: InputMaybe<GeoRestriction>;
};

export type GenerateStreamUrlProtectionsInput = {
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  geoRestriction?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateSubtitlesForAssetOutput = {
  __typename?: 'GenerateSubtitlesForAssetOutput';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateSubtitlesForAudioOutput = {
  __typename?: 'GenerateSubtitlesForAudioOutput';
  error?: Maybe<Scalars['String']['output']>;
  vtt?: Maybe<Scalars['String']['output']>;
};

export enum GeoRestriction {
  Norway = 'NORWAY',
  Sweden = 'SWEDEN'
}

export type GetUsersInput = {
  query: Scalars['String']['input'];
};

export type GrabThumbnailInput = {
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** Provider ID */
  provider: Scalars['String']['input'];
};

export type GrabThumbnailOutput = {
  __typename?: 'GrabThumbnailOutput';
  /** Thumbnail URL */
  url: Scalars['String']['output'];
};

export type HlsStreamInput = {
  audioChannelsMix?: InputMaybe<AudioChannelsMix>;
  dvrLength: Scalars['Int']['input'];
  profile?: HlsProfile;
  protections?: Array<LiveStreamProtection>;
};

export enum HlsProfile {
  Hls = 'HLS',
  Hls1080 = 'HLS1080'
}

export type InsertAdInput = {
  /** Id of an asset to insert the ad into */
  assetId: Scalars['Int']['input'];
  /** Ad duration in seconds */
  duration: Scalars['Int']['input'];
  /** Newsroom */
  newsroom: Scalars['String']['input'];
  /** Ad offset in milliseconds */
  offset?: Scalars['Int']['input'];
};

/** Get the last known state of asset ingest */
export type LastAssetIngest = AssetIngestDone | AssetIngestFailed | AssetIngestInProgress | AssetIngestNone;

export type Live = {
  asset: Asset;
};

export type LiveArchiveCutRangeInput = {
  /** Live archive start time in seconds */
  begin?: InputMaybe<Scalars['Float']['input']>;
  /** Live archive end time in seconds */
  end?: InputMaybe<Scalars['Float']['input']>;
};

export type LiveArchiveExpirationInput = {
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** Provider ID */
  provider: Scalars['String']['input'];
};

export type LiveArchiveOutput = {
  __typename?: 'LiveArchiveOutput';
  isVertical: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type LiveEncoder = {
  __typename?: 'LiveEncoder';
  events: Array<LiveEvent>;
  id: Scalars['String']['output'];
  inputs: Array<ElementalInput>;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type LiveEncoderEventsArgs = {
  assetId?: InputMaybe<Scalars['Int']['input']>;
  newsroom?: InputMaybe<Scalars['String']['input']>;
};

export type LiveEvent = {
  __typename?: 'LiveEvent';
  asset?: Maybe<Asset>;
  createTime: Scalars['Int']['output'];
  dvrLength?: Maybe<Scalars['Int']['output']>;
  encoder?: Maybe<LiveEncoder>;
  hasLivePreview?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  input?: Maybe<ElementalInput>;
  name: Scalars['String']['output'];
  networkInputUri?: Maybe<Scalars['String']['output']>;
  notifications: Array<LiveEventNotification>;
  schedule?: Maybe<Schedule>;
  status: LiveEventStatus;
};

export type LiveEventNotification = {
  __typename?: 'LiveEventNotification';
  code: Scalars['Int']['output'];
  level: LiveEventNotificationLevel;
  message: Scalars['String']['output'];
  originalMessage?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export enum LiveEventNotificationLevel {
  Alert = 'ALERT',
  Error = 'ERROR',
  Info = 'INFO'
}

export enum LiveEventStatus {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type LiveInput = {
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
};

export type LiveOutput = ElementalLive | ExternalLive | MediaLiveLive | RtmpLive;

export type LiveSchedule = {
  __typename?: 'LiveSchedule';
  action: LiveScheduleActions;
  assetId: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  /** Unix Timestamp (seconds) */
  time: Scalars['Int']['output'];
};

export enum LiveScheduleActions {
  Start = 'START',
  Stop = 'STOP'
}

export type LiveScheduleCreateInput = {
  action: LiveScheduleActions;
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  time: Scalars['Int']['input'];
};

export type LiveScheduleUpdateInput = {
  time: Scalars['Int']['input'];
};

/** Filtering is done with the AND logical operator. */
export type LiveScheduleWhereUniqueInput = {
  /** action is an exact match */
  action: LiveScheduleActions;
  /** assetId is an exact match */
  assetId: Scalars['Int']['input'];
  /** provider is an exact match, case sensitive filtering */
  provider: Scalars['String']['input'];
};

/** Filtering is done with the AND logical operator. */
export type LiveSchedulesWhereInput = {
  /** action is an exact match */
  action?: InputMaybe<LiveScheduleActions>;
  /** assetId is an exact match */
  assetId?: InputMaybe<Scalars['Int']['input']>;
  /** provider is an exact match, case sensitive filtering */
  provider?: InputMaybe<Scalars['String']['input']>;
};

export enum LiveStreamBackup {
  Medialive = 'MEDIALIVE',
  Network = 'NETWORK',
  Sdi = 'SDI'
}

export type LiveStreamBackupInput = {
  medialive?: InputMaybe<MediaLiveSourceInput>;
  network?: InputMaybe<NetworkSourceInput>;
  sdi?: InputMaybe<SdiSourceInput>;
  type: LiveStreamBackup;
};

export type LiveStreamDestinationInput = {
  server: Scalars['String']['input'];
  streamKey: Scalars['String']['input'];
};

export type LiveStreamOverlayInput = {
  /**
   * URL of the image to be inserted as an overlay.
   *
   *       Requirements for the overlay:
   *       1. Transparent background. Saved in a format supporting transparency. PNG is recommended.
   *       2. The size has to be the same as the input video size. Overlay image is going to be inserted starting from top-left corner, so sizes has to be the same to avoid cropping.
   */
  url: Scalars['String']['input'];
};

export enum LiveStreamProtection {
  Encrypted = 'ENCRYPTED',
  Geoblocked = 'GEOBLOCKED',
  TokenSecured = 'TOKEN_SECURED'
}

export enum LiveStreamProtocol {
  Hls = 'HLS'
}

export type LiveStreamProtocolInput = {
  hls?: InputMaybe<HlsStreamInput>;
  type: LiveStreamProtocol;
};

/** Controls automatic live schedule */
export type LiveStreamScheduleInput = {
  asset?: InputMaybe<AssetScheduleInput>;
  encoder?: InputMaybe<EncoderScheduleInput>;
};

export type LiveStreamSetupInput = {
  /** Backup encoder */
  backup?: InputMaybe<LiveStreamBackupInput>;
  /** Stream destination */
  destination?: InputMaybe<LiveStreamDestinationInput>;
  /** Protocol configuration */
  protocol?: InputMaybe<LiveStreamProtocolInput>;
  /** Primary encoder */
  source?: InputMaybe<LiveStreamSourceInput>;
};

export enum LiveStreamSource {
  External = 'EXTERNAL',
  Medialive = 'MEDIALIVE',
  Network = 'NETWORK',
  Sdi = 'SDI'
}

export type LiveStreamSourceInput = {
  external?: InputMaybe<ExternalSourceInput>;
  medialive?: InputMaybe<MediaLiveSourceInput>;
  network?: InputMaybe<NetworkSourceInput>;
  sdi?: InputMaybe<SdiSourceInput>;
  type: LiveStreamSource;
};

/** Info object for the stream url */
export type LiveStreamUrlInfo = {
  __typename?: 'LiveStreamUrlInfo';
  /** Stream configuration cdn id */
  cdnId: Scalars['Int']['output'];
  /** Name of the newsroom */
  newsroom: Scalars['String']['output'];
  publishUrl: PublishUrl;
  /** Key used for streaming */
  streamKey: Scalars['String']['output'];
};

export type ManageUserFailure = {
  __typename?: 'ManageUserFailure';
  message: Scalars['String']['output'];
};

export type ManageUserOutput = ManageUserFailure | User;

export type MediaLiveChannel = {
  __typename?: 'MediaLiveChannel';
  asset: AssetIdProvider;
  id: Scalars['Int']['output'];
  input: MediaLiveInput;
  schedule?: Maybe<Schedule>;
  state: MediaLiveChannelState;
};

export enum MediaLiveChannelState {
  Creating = 'CREATING',
  Idle = 'IDLE',
  Running = 'RUNNING',
  Starting = 'STARTING',
  Stopping = 'STOPPING'
}

export type MediaLiveInput = {
  __typename?: 'MediaLiveInput';
  channel?: Maybe<MediaLiveChannel>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: MediaLiveInputType;
  urls: Array<Scalars['String']['output']>;
};

export enum MediaLiveInputType {
  Pull = 'PULL',
  Push = 'PUSH'
}

export type MediaLiveInputWhereInput = {
  newsroom: Scalars['String']['input'];
  reserved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaLiveLive = Live & ScheduledLive & {
  __typename?: 'MediaLiveLive';
  asset: Asset;
  channel: MediaLiveLiveChannel;
  schedule: Schedule;
};

export type MediaLiveLiveChannel = {
  __typename?: 'MediaLiveLiveChannel';
  id: Scalars['Int']['output'];
  input: MediaLiveInput;
  state: MediaLiveChannelState;
};

export type MediaLiveSourceInput = {
  reserved?: InputMaybe<MediaLiveSourceInputReserved>;
  type: MediaLiveSourceInputType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLiveSourceInputReserved = {
  /** Existing MediaLive Input ID */
  inputId: Scalars['String']['input'];
};

export enum MediaLiveSourceInputType {
  Pull = 'PULL',
  Push = 'PUSH',
  Reserved = 'RESERVED'
}

export enum MediaType {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export type MergePlaylistsInput = {
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Acquire lock for asset (lock has been acquired only when true value is returned) */
  acquireAssetPodmeLock: Scalars['Boolean']['output'];
  /** Acquire lock for category (lock has been acquired only when true value is returned) */
  acquireCategoryPodmeLock: Scalars['Boolean']['output'];
  /** Cancel running an ad, does nothing otherwise */
  cancelAd: Scalars['Boolean']['output'];
  /** Changes asset restrictions */
  changeAssetRestrictions: Scalars['Boolean']['output'];
  convertVideo: ConvertVideoOutput;
  /** Creates a custom preview of the given asset */
  createAssetPreview: PreviewResponse;
  createAssetSchedule?: Maybe<AssetSchedule>;
  createClips: CreateClipsResponse;
  createLiveSchedule?: Maybe<LiveSchedule>;
  createLiveStream: CreateLiveStreamOutput;
  createNotificationSchedule?: Maybe<NotificationSchedule>;
  createPlaylist: CreatePlaylistResponse;
  createPodmeEpisode: CreatePodmeEpisodeResult;
  createPodmePodcast: CreatePodmePodcastResult;
  createRtmpPush: CreateRtmpPushOutput;
  createUser?: Maybe<ManageUserOutput>;
  cropLiveArchive: CropLiveArchiveOutput;
  deleteAssetSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteLiveSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteNotificationSchedule?: Maybe<Scalars['Boolean']['output']>;
  deletePlaylist: DeletePlaylistResponse;
  deletePodmeEpisode: Scalars['Boolean']['output'];
  deletePodmePodcast: Scalars['Boolean']['output'];
  duplicateLiveStream: DuplicateLiveStreamOutput;
  /** Generate access token */
  generateAkamaiToken: GenerateAkamaiTokenOutput;
  /** Generate subtitles for an asset */
  generateSubtitlesForAsset?: Maybe<GenerateSubtitlesForAssetOutput>;
  /** Generate subtitles for an audio file */
  generateSubtitlesForAudio?: Maybe<GenerateSubtitlesForAudioOutput>;
  grabThumbnail: GrabThumbnailOutput;
  /** Triggers an ad insertion */
  insertAd: Scalars['Boolean']['output'];
  lockPlaylist: Scalars['Boolean']['output'];
  /** Merges a backup playlist to the master one on Akamai for elemental events */
  mergePlaylists: Scalars['Boolean']['output'];
  /** Set or remove any metadata for asset */
  modifyAssetPodmeMetadata: AssetPodmeMetadata;
  /** Set or remove any metadata for category */
  modifyCategoryPodmeMetadata: CategoryPodmeMetadata;
  prepareLiveArchive: PrepareLiveArchiveOutput;
  prepareLiveStream: PrepareLiveStreamOutput;
  prepareRtmpPush: PrepareRtmpPushOutput;
  /** Release lock for asset */
  releaseAssetPodmeLock: Scalars['Boolean']['output'];
  /** Release lock for category */
  releaseCategoryPodmeLock: Scalars['Boolean']['output'];
  sendPushNotification?: Maybe<SendPushNotificationResponse>;
  /** Generate signed stream url */
  signAssetStreamUrls: Array<StreamUrl>;
  /** Start a live video on demand */
  startLiveStream: Scalars['Boolean']['output'];
  /** Start a scheduled live video by the Scheduler API */
  startScheduledLiveStream: Scalars['Boolean']['output'];
  /** Stop a live video on demand */
  stopLiveStream: Scalars['Boolean']['output'];
  /** Stop a scheduled live video by the Scheduler API */
  stopScheduledLiveStream: Scalars['Boolean']['output'];
  transcodeVideo: TranscodeVideoResponse;
  trimAsset: Scalars['Boolean']['output'];
  unlockPlaylist: Scalars['Boolean']['output'];
  unpublishLiveAsset: Scalars['Boolean']['output'];
  updateAssetSchedule?: Maybe<AssetSchedule>;
  updateLiveAssetAfterStop: Scalars['Boolean']['output'];
  updateLiveSchedule?: Maybe<LiveSchedule>;
  updateLiveStream: Scalars['Boolean']['output'];
  updateNotificationSchedule?: Maybe<NotificationSchedule>;
  updatePlaylist: UpdatePlaylistResponse;
  updatePodmeEpisode: Scalars['Boolean']['output'];
  updatePodmePodcast: Scalars['Boolean']['output'];
  updateUser?: Maybe<ManageUserOutput>;
  /** Upload a custom preview for asset */
  uploadAssetPreview: PreviewResponse;
  /** Upload a custom preview for category */
  uploadCategoryPreview: PreviewResponse;
  /** Uploads subtitles CDN */
  uploadSubtitles: UploadSubtitlesOutput;
};


export type MutationAcquireAssetPodmeLockArgs = {
  where: AssetPodmeWhereInput;
};


export type MutationAcquireCategoryPodmeLockArgs = {
  where: CategoryPodmeWhereInput;
};


export type MutationCancelAdArgs = {
  input: CancelAdInput;
};


export type MutationChangeAssetRestrictionsArgs = {
  input: ChangeAssetRestrictionsInput;
};


export type MutationConvertVideoArgs = {
  input: ConvertVideoInput;
};


export type MutationCreateAssetPreviewArgs = {
  artifacts?: Array<Scalars['String']['input']>;
  assetId: Scalars['Int']['input'];
  cutRange: CutRange;
  editedBy: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};


export type MutationCreateAssetScheduleArgs = {
  data: AssetScheduleCreateInput;
};


export type MutationCreateClipsArgs = {
  data: CreateClipsInput;
};


export type MutationCreateLiveScheduleArgs = {
  data: LiveScheduleCreateInput;
};


export type MutationCreateLiveStreamArgs = {
  input: CreateLiveStreamInput;
};


export type MutationCreateNotificationScheduleArgs = {
  data: NotificationScheduleCreateInput;
};


export type MutationCreatePlaylistArgs = {
  data: CreatePlaylistInput;
};


export type MutationCreatePodmeEpisodeArgs = {
  data: CreatePodmeEpisodeInput;
};


export type MutationCreatePodmePodcastArgs = {
  data: CreatePodmePodcastInput;
};


export type MutationCreateRtmpPushArgs = {
  input: CreateRtmpPushInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationCropLiveArchiveArgs = {
  input: CropLiveArchiveInput;
};


export type MutationDeleteAssetScheduleArgs = {
  where: AssetScheduleWhereUniqueInput;
};


export type MutationDeleteLiveScheduleArgs = {
  where: LiveScheduleWhereUniqueInput;
};


export type MutationDeleteNotificationScheduleArgs = {
  where: NotificationScheduleWhereUniqueInput;
};


export type MutationDeletePlaylistArgs = {
  data: DeletePlaylistInput;
};


export type MutationDeletePodmeEpisodeArgs = {
  data: DeletePodmeEpisodeInput;
};


export type MutationDeletePodmePodcastArgs = {
  data: DeletePodmePodcastInput;
};


export type MutationDuplicateLiveStreamArgs = {
  input: DuplicateLiveStreamInput;
};


export type MutationGenerateAkamaiTokenArgs = {
  input: GenerateAkamaiTokenInput;
};


export type MutationGenerateSubtitlesForAssetArgs = {
  id: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};


export type MutationGenerateSubtitlesForAudioArgs = {
  url: Scalars['String']['input'];
};


export type MutationGrabThumbnailArgs = {
  input: GrabThumbnailInput;
};


export type MutationInsertAdArgs = {
  input: InsertAdInput;
};


export type MutationLockPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMergePlaylistsArgs = {
  input: MergePlaylistsInput;
};


export type MutationModifyAssetPodmeMetadataArgs = {
  metadata: AssetPodmeMetadataInput;
  where: AssetPodmeWhereInput;
};


export type MutationModifyCategoryPodmeMetadataArgs = {
  metadata: CategoryPodmeMetadataInput;
  where: CategoryPodmeWhereInput;
};


export type MutationPrepareLiveArchiveArgs = {
  input: PrepareLiveArchiveInput;
};


export type MutationPrepareLiveStreamArgs = {
  input: PrepareLiveStreamInput;
};


export type MutationPrepareRtmpPushArgs = {
  input: PrepareRtmpPushInput;
};


export type MutationReleaseAssetPodmeLockArgs = {
  where: AssetPodmeWhereInput;
};


export type MutationReleaseCategoryPodmeLockArgs = {
  where: CategoryPodmeWhereInput;
};


export type MutationSendPushNotificationArgs = {
  data: SendPushNotificationInput;
};


export type MutationSignAssetStreamUrlsArgs = {
  input: SignAssetStreamUrlsInput;
};


export type MutationStartLiveStreamArgs = {
  input: ControlLiveStreamInput;
};


export type MutationStartScheduledLiveStreamArgs = {
  input: ControlLiveStreamInput;
};


export type MutationStopLiveStreamArgs = {
  input: ControlLiveStreamInput;
};


export type MutationStopScheduledLiveStreamArgs = {
  input: ControlLiveStreamInput;
};


export type MutationTranscodeVideoArgs = {
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
  options?: InputMaybe<TranscodeVideoOptions>;
  sourceUri: Scalars['String']['input'];
};


export type MutationTrimAssetArgs = {
  data: CreateTrimInput;
};


export type MutationUnlockPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpublishLiveAssetArgs = {
  input: ControlLiveStreamInput;
};


export type MutationUpdateAssetScheduleArgs = {
  data: AssetScheduleUpdateInput;
  where: AssetScheduleWhereUniqueInput;
};


export type MutationUpdateLiveAssetAfterStopArgs = {
  input: ControlLiveStreamInput;
};


export type MutationUpdateLiveScheduleArgs = {
  data: LiveScheduleUpdateInput;
  where: LiveScheduleWhereUniqueInput;
};


export type MutationUpdateLiveStreamArgs = {
  input: UpdateLiveStreamInput;
};


export type MutationUpdateNotificationScheduleArgs = {
  data: NotificationScheduleUpdateInput;
  where: NotificationScheduleWhereUniqueInput;
};


export type MutationUpdatePlaylistArgs = {
  data: UpdatePlaylistInput;
};


export type MutationUpdatePodmeEpisodeArgs = {
  data: UpdatePodmeEpisodeInput;
};


export type MutationUpdatePodmePodcastArgs = {
  data: UpdatePodmePodcastInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUploadAssetPreviewArgs = {
  artifacts?: Array<Scalars['String']['input']>;
  assetId: Scalars['Int']['input'];
  editedBy: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  source: Scalars['String']['input'];
};


export type MutationUploadCategoryPreviewArgs = {
  artifacts?: Array<Scalars['String']['input']>;
  categoryId: Scalars['Int']['input'];
  editedBy: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  source: Scalars['String']['input'];
};


export type MutationUploadSubtitlesArgs = {
  input: UploadSubtitlesInput;
};

export type NetworkSourceInput = {
  encoderId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type NotificationData = {
  __typename?: 'NotificationData';
  /** Importance of given follow relation (0-100) */
  importance: Scalars['Int']['output'];
  /** Follow items */
  items: Array<NotificationDataItem>;
  /** Follow relation owner */
  owner: Scalars['String']['output'];
  /** Push notification data */
  push: NotificationDataPush;
};

export type NotificationDataInput = {
  /** Importance of given follow relation (0-100) */
  importance: Scalars['Int']['input'];
  /** Follow items */
  items: Array<NotificationDataItemInput>;
  /** Follow relation owner */
  owner: Scalars['String']['input'];
  /** Push notification data */
  push: NotificationDataPushInput;
};

export type NotificationDataItem = {
  __typename?: 'NotificationDataItem';
  /** Follow context */
  context?: Maybe<Scalars['String']['output']>;
  /** Follow ID */
  id: Scalars['String']['output'];
  /** Follow namespace */
  namespace: Scalars['String']['output'];
  /** Follow type */
  type: Scalars['String']['output'];
};

export type NotificationDataItemInput = {
  /** Follow context */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Follow ID */
  id: Scalars['String']['input'];
  /** Follow namespace */
  namespace: Scalars['String']['input'];
  /** Follow type */
  type: Scalars['String']['input'];
};

export type NotificationDataPush = {
  __typename?: 'NotificationDataPush';
  /** Push notification body */
  body: Scalars['String']['output'];
  /** List of push topic IDs to exclude when determining push recipients */
  excludedTopics?: Maybe<Array<Scalars['String']['output']>>;
  /** Url of an image to be shown on push notification */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Push notification target (e.g. specific article) */
  target: Scalars['String']['output'];
  /** Push notification title */
  title?: Maybe<Scalars['String']['output']>;
  /** List of push topic IDs used when determining push recipients */
  topics?: Maybe<Array<Scalars['String']['output']>>;
};

export type NotificationDataPushInput = {
  /** Push notification body */
  body: Scalars['String']['input'];
  /** List of push topic IDs to exclude when determining push recipients */
  excludedTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Url of an image to be shown on push notification */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Push notification target (e.g. specific article) */
  target: Scalars['String']['input'];
  /** Push notification title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** List of push topic IDs used when determining push recipients */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationSchedule = {
  __typename?: 'NotificationSchedule';
  /** Notification schedule action */
  action: NotificationScheduleActions;
  /** Asset ID */
  assetId: Scalars['Int']['output'];
  /** Push notification body */
  notificationBody?: Maybe<Scalars['String']['output']>;
  /**
   * Notification schedule additional data
   * @deprecated Replaced by notificationBody field
   */
  notificationData?: Maybe<NotificationData>;
  /** Provider ID */
  provider: Scalars['String']['output'];
  /** Unix timestamp (seconds) */
  time: Scalars['Int']['output'];
};

export enum NotificationScheduleActions {
  Push = 'PUSH'
}

export type NotificationScheduleCreateInput = {
  /** Notification schedule action */
  action: NotificationScheduleActions;
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** Push notification body */
  notificationBody?: InputMaybe<Scalars['String']['input']>;
  /** Provider ID */
  provider: Scalars['String']['input'];
  /** Unix timestamp (seconds) */
  time: Scalars['Int']['input'];
};

export type NotificationScheduleUpdateInput = {
  /** Push notification body */
  notificationBody?: InputMaybe<Scalars['String']['input']>;
  /** Unix timestamp (seconds) */
  time: Scalars['Int']['input'];
};

/** Filtering is done with the AND logical operator. */
export type NotificationScheduleWhereUniqueInput = {
  /** action is an exact match */
  action: NotificationScheduleActions;
  /** assetId is an exact match */
  assetId: Scalars['Int']['input'];
  /** provider is an exact match, case sensitive filtering */
  provider: Scalars['String']['input'];
};

/** Filtering is done with the AND logical operator. */
export type NotificationSchedulesWhereInput = {
  /** action is an exact match */
  action?: InputMaybe<NotificationScheduleActions>;
  /** assetId is an exact match */
  assetId?: InputMaybe<Scalars['Int']['input']>;
  /** provider is an exact match, case sensitive filtering */
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type Overlay = {
  params?: InputMaybe<OverlayParams>;
  sourceUri: Scalars['String']['input'];
};

export enum OverlayOrigin {
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT',
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT'
}

export type OverlayParams = {
  height: Scalars['Int']['input'];
  origin: OverlayOrigin;
  width: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type Playlist = {
  __typename?: 'Playlist';
  duration: Scalars['Float']['output'];
  segments: Array<PlaylistSegment>;
  url: Scalars['String']['output'];
};

export type PlaylistAsset = {
  __typename?: 'PlaylistAsset';
  id: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
};

export type PlaylistAssetInput = {
  id: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type PlaylistItem = PositionedPlaylistAsset | PositionedPlaylistItemPlaylist;

export type PlaylistItemInput = {
  asset?: InputMaybe<PlaylistAssetInput>;
  playlist?: InputMaybe<PlaylistItemPlaylistInput>;
  position: Scalars['Int']['input'];
};

export type PlaylistItemPlaylist = {
  __typename?: 'PlaylistItemPlaylist';
  id: Scalars['ID']['output'];
  provider: Scalars['String']['output'];
};

export type PlaylistItemPlaylistInput = {
  id: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type PlaylistLabel = {
  __typename?: 'PlaylistLabel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PlaylistLabelInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: Scalars['String']['input'];
};

export type PlaylistSegment = {
  __typename?: 'PlaylistSegment';
  discontinuity: Scalars['Boolean']['output'];
  duration: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type PodmeCategory = {
  __typename?: 'PodmeCategory';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PodmeEpisode = {
  __typename?: 'PodmeEpisode';
  audioHlsUrl?: Maybe<Scalars['String']['output']>;
  audioMp3Url?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  episodeLength?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isPremium: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  podcastId: Scalars['Int']['output'];
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  rssId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PodmeEpisodeQueryInput = {
  id: Scalars['Int']['input'];
};

export type PodmeEpisodesQueryInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  podcastId: Scalars['Int']['input'];
};

export type PodmePodcast = {
  __typename?: 'PodmePodcast';
  authorName?: Maybe<Scalars['String']['output']>;
  categoryIds?: Maybe<Array<Scalars['Int']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isPublished: Scalars['Boolean']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rssFeedLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PodmePodcastQueryInput = {
  id: Scalars['Int']['input'];
};

export type PositionedPlaylistAsset = {
  __typename?: 'PositionedPlaylistAsset';
  asset: PlaylistAsset;
  position: Scalars['Int']['output'];
};

export type PositionedPlaylistItemPlaylist = {
  __typename?: 'PositionedPlaylistItemPlaylist';
  playlist: PlaylistItemPlaylist;
  position: Scalars['Int']['output'];
};

export type PrepareLiveArchiveInput = {
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** Adjust start time and end time of live archive */
  cutRange?: InputMaybe<LiveArchiveCutRangeInput>;
  /** Provider ID */
  provider: Scalars['String']['input'];
};

export type PrepareLiveArchiveOutput = {
  __typename?: 'PrepareLiveArchiveOutput';
  /** Live archive video URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type PrepareLiveStreamInput = {
  assetId: Scalars['Int']['input'];
  audioNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
  deinterlace?: InputMaybe<Scalars['Boolean']['input']>;
  liveArchive?: InputMaybe<Scalars['Boolean']['input']>;
  livePreview?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<PrepareLiveStreamMetadataInput>;
  newsroom: Scalars['String']['input'];
  overlay?: InputMaybe<LiveStreamOverlayInput>;
  schedule?: InputMaybe<LiveStreamScheduleInput>;
  setup: LiveStreamSetupInput;
  vertical?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Basic stream metadata to be saved during update. */
export type PrepareLiveStreamMetadataInput = {
  /** Asset access. Should be used in conjunction with LiveStreamProtection of HLSStreamInput */
  access?: InputMaybe<Scalars['String']['input']>;
  /** User name or email. */
  editedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PrepareLiveStreamOutput = {
  __typename?: 'PrepareLiveStreamOutput';
  asset: Asset;
  events: Array<LiveEvent>;
};

export type PrepareRtmpPushInput = {
  assetId: Scalars['Int']['input'];
  metadata: PrepareLiveStreamMetadataInput;
  newsroom: Scalars['String']['input'];
  streamKey: Scalars['String']['input'];
  streamType: RtmpStreamTypeInput;
};

export type PrepareRtmpPushOutput = {
  __typename?: 'PrepareRtmpPushOutput';
  asset: Asset;
};

export type PreviewErrorResponse = {
  __typename?: 'PreviewErrorResponse';
  message: Scalars['String']['output'];
  result: Scalars['Boolean']['output'];
};

export type PreviewResponse = PreviewErrorResponse | PreviewSuccessResponse;

export type PreviewSuccessResponse = {
  __typename?: 'PreviewSuccessResponse';
  result: Scalars['Boolean']['output'];
};

export type Protections = {
  /** Access level identifier to apply to the output stream */
  accessLevel?: InputMaybe<AccessLevel>;
  /** Geographical area to limit the output stream availability */
  geoRestriction?: InputMaybe<GeoRestriction>;
};

export type PublishUrl = {
  __typename?: 'PublishUrl';
  /** Backup publishing URL */
  backup: Scalars['Url']['output'];
  /** Primary publishing URL */
  primary: Scalars['Url']['output'];
};

export type Query = {
  __typename?: 'Query';
  assetHistory: Array<Scalars['AssetHistory']['output']>;
  assetHistoryRecord?: Maybe<Scalars['AssetHistory']['output']>;
  /** Get metadata for asset */
  assetPodmeMetadata: AssetPodmeMetadata;
  assetSchedules?: Maybe<Array<AssetSchedule>>;
  /** Returns Content API newsroom ID by SVP provider */
  capiNewsroomBySvpProvider: Scalars['String']['output'];
  /** Get metadata for category */
  categoryPodmeMetadata: CategoryPodmeMetadata;
  cuttingroomChannels: Array<CuttingroomChannel>;
  encoderInputPreview: EncoderInputPreview;
  encoders: Array<LiveEncoder>;
  generateAkamaiUrl: GenerateAkamaiUrlOutput;
  /** Returns list of authors by ids */
  getAuthors: Array<Author>;
  /** Returns engagement stats */
  getEngagementStatsApiKey: StatsApiKey;
  /** Returns stories by list of ids */
  getStories: Array<Story>;
  getUsers: Array<User>;
  lastAssetIngest?: Maybe<LastAssetIngest>;
  lastAssetsIngest?: Maybe<Array<Maybe<LastAssetIngest>>>;
  /** Returns tags from Content API */
  listTags: Array<Tag>;
  live: LiveOutput;
  liveArchive?: Maybe<LiveArchiveOutput>;
  liveArchiveExpiration?: Maybe<Scalars['Int']['output']>;
  liveSchedules?: Maybe<Array<LiveSchedule>>;
  /** Parse live stream url into standardized parts */
  liveStreamUrlInfo: LiveStreamUrlInfo;
  mediaLiveChannels: Array<MediaLiveChannel>;
  mediaLiveInputs: Array<MediaLiveInput>;
  /** Get notification schedules list */
  notificationSchedules?: Maybe<Array<NotificationSchedule>>;
  playlists: Array<Playlist>;
  podmeCategories: Array<PodmeCategory>;
  podmeEpisode: PodmeEpisode;
  podmeEpisodes: Array<PodmeEpisode>;
  podmePodcast: PodmePodcast;
  podmePodcasts: Array<PodmePodcast>;
  providerPlaylists: Array<StreamPlaylist>;
  randomEncoderConfiguration?: Maybe<RandomEncoderConfigurationOutput>;
  /** Returns authors per query */
  searchAuthors: Array<Author>;
  /** Returns stories per query */
  searchStories: Array<Story>;
  /** Returns tags per asset */
  searchTags: Array<Tag>;
  streamConfiguration: StreamConfiguration;
  streamConfigurationForAsset?: Maybe<StreamConfiguration>;
  streamConfigurations: Array<StreamConfiguration>;
  /** Stream duration in ms */
  streamDuration?: Maybe<Scalars['Int']['output']>;
  /** Lists all asset's files on the storage */
  streamStorageInfo: StreamStorageInfoOutput;
  /** Parse stream url into standardized parts */
  streamUrlInfo: StreamUrlInfo;
  /** Returns suggested tags from Content API */
  suggestTags: Array<Tag>;
  /** Returns suggested tags from Content API */
  suggestTagsForAsset: Array<Tag>;
  /** Returns SVP providers by Content API newsroom ID */
  svpProvidersByCapiNewsroom: Array<Scalars['String']['output']>;
};


export type QueryAssetHistoryArgs = {
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
};


export type QueryAssetHistoryRecordArgs = {
  assetId: Scalars['Int']['input'];
  historyId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
};


export type QueryAssetPodmeMetadataArgs = {
  where: AssetPodmeWhereInput;
};


export type QueryAssetSchedulesArgs = {
  where?: InputMaybe<AssetSchedulesWhereInput>;
};


export type QueryCapiNewsroomBySvpProviderArgs = {
  provider: Scalars['String']['input'];
};


export type QueryCategoryPodmeMetadataArgs = {
  where: CategoryPodmeWhereInput;
};


export type QueryCuttingroomChannelsArgs = {
  newsroom: Scalars['String']['input'];
};


export type QueryEncoderInputPreviewArgs = {
  input: EncoderInputPreviewInput;
};


export type QueryEncodersArgs = {
  newsroom: Scalars['String']['input'];
};


export type QueryGenerateAkamaiUrlArgs = {
  input: GenerateAkamaiUrlInput;
};


export type QueryGetAuthorsArgs = {
  ids: Array<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};


export type QueryGetEngagementStatsApiKeyArgs = {
  provider: Scalars['String']['input'];
};


export type QueryGetStoriesArgs = {
  ids: Array<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  data: GetUsersInput;
};


export type QueryLastAssetIngestArgs = {
  assetCriteria: AssetCriteria;
};


export type QueryLastAssetsIngestArgs = {
  assetsCriteria: Array<AssetCriteria>;
};


export type QueryListTagsArgs = {
  ids: Array<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};


export type QueryLiveArgs = {
  input: LiveInput;
};


export type QueryLiveArchiveArgs = {
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
};


export type QueryLiveArchiveExpirationArgs = {
  input: LiveArchiveExpirationInput;
};


export type QueryLiveSchedulesArgs = {
  where?: InputMaybe<LiveSchedulesWhereInput>;
};


export type QueryLiveStreamUrlInfoArgs = {
  url: Scalars['Url']['input'];
};


export type QueryMediaLiveChannelsArgs = {
  newsroom: Scalars['String']['input'];
};


export type QueryMediaLiveInputsArgs = {
  where: MediaLiveInputWhereInput;
};


export type QueryNotificationSchedulesArgs = {
  where?: InputMaybe<NotificationSchedulesWhereInput>;
};


export type QueryPlaylistsArgs = {
  url: Scalars['String']['input'];
};


export type QueryPodmeEpisodeArgs = {
  data: PodmeEpisodeQueryInput;
};


export type QueryPodmeEpisodesArgs = {
  data: PodmeEpisodesQueryInput;
};


export type QueryPodmePodcastArgs = {
  data: PodmePodcastQueryInput;
};


export type QueryProviderPlaylistsArgs = {
  filter?: InputMaybe<FilterInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryRandomEncoderConfigurationArgs = {
  input: EncoderParamsInput;
  where?: InputMaybe<EncoderParamsWhere>;
};


export type QuerySearchAuthorsArgs = {
  provider: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchStoriesArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchTagsArgs = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  query?: Scalars['String']['input'];
};


export type QueryStreamConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStreamConfigurationForAssetArgs = {
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
};


export type QueryStreamConfigurationsArgs = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  cdnId?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<MediaType>;
  newsroom?: InputMaybe<Scalars['String']['input']>;
  streamingProtocol?: InputMaybe<StreamingProtocol>;
  type?: InputMaybe<StreamType>;
};


export type QueryStreamDurationArgs = {
  input?: InputMaybe<StreamDurationInput>;
};


export type QueryStreamStorageInfoArgs = {
  input: StreamStorageInfoInput;
};


export type QueryStreamUrlInfoArgs = {
  url: Scalars['Url']['input'];
};


export type QuerySuggestTagsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  subtitlesUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};


export type QuerySuggestTagsForAssetArgs = {
  assetId: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};


export type QuerySvpProvidersByCapiNewsroomArgs = {
  newsroom: Scalars['String']['input'];
};

/** Returns a randomly chosen encoder configuration from filtered ones */
export type RandomEncoderConfigurationOutput = {
  __typename?: 'RandomEncoderConfigurationOutput';
  credentials?: Maybe<StreamCredentials>;
  playbackUrl: Scalars['String']['output'];
  publishUrl: Scalars['String']['output'];
};

export type RoleInput = {
  newsroom: Scalars['String']['input'];
  roleType: Scalars['String']['input'];
};

export type RoleOutput = {
  __typename?: 'RoleOutput';
  newsroom: Scalars['String']['output'];
  roleType: Scalars['String']['output'];
};

export type RtmpLive = Live & {
  __typename?: 'RtmpLive';
  asset: Asset;
  streamKey: Scalars['String']['output'];
};

export enum RtmpStreamTypeInput {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export type SdiSourceInput = {
  encoderId: Scalars['String']['input'];
  inputId: Scalars['Int']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  endTime?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledLive = {
  schedule: Schedule;
};

export type SendPushNotificationErrorResponse = {
  __typename?: 'SendPushNotificationErrorResponse';
  /** Error message */
  errorMessage: Scalars['String']['output'];
};

export type SendPushNotificationInput = {
  /** Asset ID */
  assetId: Scalars['Int']['input'];
  /** Notification body */
  notificationBody?: InputMaybe<Scalars['String']['input']>;
  /** Provider ID */
  provider: Scalars['String']['input'];
};

export type SendPushNotificationResponse = SendPushNotificationErrorResponse | SendPushNotificationSuccessResponse;

export type SendPushNotificationSuccessResponse = {
  __typename?: 'SendPushNotificationSuccessResponse';
  /** Number of users that received push */
  numRecipients: Scalars['Int']['output'];
  /** UUIDs of pushes sent to users */
  pushIds: Array<Scalars['String']['output']>;
};

export type ServiceType = {
  __typename?: 'ServiceType';
  sdl: Scalars['String']['output'];
};

export type SignAssetStreamUrlsInput = {
  /** SVP asset id */
  assetId: Scalars['Int']['input'];
  /** Token lifetime in seconds */
  expirationTime: Scalars['Int']['input'];
  /** SVP provider */
  provider: Scalars['String']['input'];
};

export type SourceAudioChannel = {
  channelId: Scalars['Int']['input'];
  gain: Scalars['Int']['input'];
};

export type StatsApiKey = {
  __typename?: 'StatsApiKey';
  value?: Maybe<Scalars['String']['output']>;
};

export type StereoMix = {
  leftChannel: Array<SourceAudioChannel>;
  rightChannel: Array<SourceAudioChannel>;
};

export type Storage = {
  __typename?: 'Storage';
  directory: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
};

export type Story = {
  __typename?: 'Story';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated?: Maybe<Scalars['String']['output']>;
};

export type StreamAccess = {
  __typename?: 'StreamAccess';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StreamConfiguration = {
  __typename?: 'StreamConfiguration';
  access?: Maybe<StreamAccess>;
  archive: ArchiveInput;
  cdnId: Scalars['String']['output'];
  credentials?: Maybe<StreamCredentials>;
  id: Scalars['ID']['output'];
  mediaType: MediaType;
  name: Scalars['String']['output'];
  newsrooms: Array<Scalars['String']['output']>;
  protections: Array<StreamProtection>;
  storage?: Maybe<Storage>;
  streamingProtocol?: Maybe<StreamingProtocol>;
  type: StreamType;
  urlPatterns: Array<StreamUrlPattern>;
};

export type StreamCredentials = {
  __typename?: 'StreamCredentials';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type StreamDurationInput = {
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type StreamPlaylist = {
  __typename?: 'StreamPlaylist';
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<PlaylistItem>;
  labels: Array<PlaylistLabel>;
  locked: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  searchQuery?: Maybe<Scalars['String']['output']>;
};

export enum StreamProtection {
  Encrypted = 'ENCRYPTED',
  Geoblocked = 'GEOBLOCKED',
  PlayerVerified = 'PLAYER_VERIFIED',
  TokenSecured = 'TOKEN_SECURED'
}

export type StreamStorageFileInfo = {
  __typename?: 'StreamStorageFileInfo';
  datetime: Scalars['DateTime']['output'];
  /** File path on the storage */
  filePath: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Float']['output'];
};

export type StreamStorageInfoInput = {
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type StreamStorageInfoOutput = {
  __typename?: 'StreamStorageInfoOutput';
  files: Array<StreamStorageFileInfo>;
};

export enum StreamType {
  Live = 'LIVE',
  Vod = 'VOD'
}

export type StreamUrl = {
  __typename?: 'StreamUrl';
  format: StreamUrlFormat;
  url: Scalars['String']['output'];
};

export enum StreamUrlFormat {
  Hds = 'HDS',
  Hls = 'HLS',
  Mp4 = 'MP4'
}

/** Info object for the stream url */
export type StreamUrlInfo = {
  __typename?: 'StreamUrlInfo';
  /** Month when the content was created */
  month: Scalars['String']['output'];
  /** Name of the newsroom */
  newsroom: Scalars['String']['output'];
  /**
   * Location of the origin files - when asset has protection(geoblock/encryption) it will return path with protection,
   *         eg. https://amd-vgtv.akamaized.net/vgtv/geoblocked-norway/tokenSecured/encrypted-plus/2024/06/666176cf2a52d400084f1a10/,480_270_455,640_360_789,960_540_1666,1280_720_2953,1920_1080_5710,/master.m3u8 => netstorage://amd-vgtv-nsu.akamaihd.net/486346/amd/vgtv/geoblocked-norway/tokenSecured/encrypted-plus/2024/06/666176cf2a52d400084f1a10
   */
  originUrl: Scalars['String']['output'];
  /**
   * Location of the origin files - when asset has protection(geoblock/encryption) it will return path without protection
   *         eg. https://amd-vgtv.akamaized.net/vgtv/geoblocked-norway/tokenSecured/encrypted-plus/2024/06/666176cf2a52d400084f1a10/,480_270_455,640_360_789,960_540_1666,1280_720_2953,1920_1080_5710,/master.m3u8 => netstorage://amd-vgtv-nsu.akamaihd.net/486346/amd/vgtv/vod/2024/06/666176cf2a52d400084f1a10
   */
  originUrlWithoutProtection: Scalars['String']['output'];
  /** Base path where all source files are located */
  path: Scalars['String']['output'];
  /** Types of applied stream url protections */
  protection: StreamUrlInfoProtection;
  /**
   * List of stream protections
   * @deprecated Please use protection field which is compatible with generateAkamaiUrl query
   */
  protections: Array<Scalars['String']['output']>;
  /** List of stream qualities */
  qualities: Array<Scalars['String']['output']>;
  /** YATS ID */
  yatsId: Scalars['ID']['output'];
  /** Year when the content was created */
  year: Scalars['String']['output'];
};

/** Types of protections applied on the stream url */
export type StreamUrlInfoProtection = {
  __typename?: 'StreamUrlInfoProtection';
  /** The type of access level applied to the stream url */
  accessLevel?: Maybe<AccessLevel>;
  /** Geo restriction which is applied to the stream url */
  geoRestriction?: Maybe<GeoRestriction>;
};

export type StreamUrlPattern = {
  __typename?: 'StreamUrlPattern';
  baseUrl: Scalars['String']['output'];
  explode: Scalars['String']['output'];
  format: StreamUrlFormat;
  implode: Scalars['String']['output'];
};

export type StreamUrls = {
  __typename?: 'StreamUrls';
  hls: Scalars['String']['output'];
};

export enum StreamingProtocol {
  Hls = 'HLS',
  Rtmp = 'RTMP'
}

export type Tag = {
  __typename?: 'Tag';
  /** Title of the tag in the global context */
  globalTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Title of the tag in the newsroom context */
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TranscodeVideoOptions = {
  encodingProfile?: InputMaybe<EncodingProfile>;
  protections?: InputMaybe<Protections>;
  transformations?: InputMaybe<Transformations>;
};

export type TranscodeVideoResponse = {
  __typename?: 'TranscodeVideoResponse';
  assetId: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
};

/** Video transformations to be performed */
export type Transformations = {
  /** Media file cut specification */
  cuts?: InputMaybe<Array<WeakCutRange>>;
  /** Image overlay specification */
  overlays?: InputMaybe<Array<Overlay>>;
  preservePoster?: InputMaybe<Scalars['Boolean']['input']>;
  preservePreview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLiveStreamInput = {
  assetId: Scalars['Int']['input'];
  metadata: UpdateLiveStreamMetadataInput;
  newsroom: Scalars['String']['input'];
  schedule?: InputMaybe<LiveStreamScheduleInput>;
};

export type UpdateLiveStreamMetadataInput = {
  /** User name or email. */
  editedBy: Scalars['String']['input'];
};

export type UpdatePlaylistInput = {
  header?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  items?: Array<PlaylistItemInput>;
  labels?: InputMaybe<Array<PlaylistLabelInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlaylistResponse = {
  __typename?: 'UpdatePlaylistResponse';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  playlist?: Maybe<StreamPlaylist>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePodmeEpisodeInput = {
  audioHlsUrl: Scalars['String']['input'];
  audioMp3Url: Scalars['String']['input'];
  description: Scalars['String']['input'];
  episodeLength: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isPremium: Scalars['Boolean']['input'];
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  rssId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdatePodmePodcastInput = {
  authorName: Scalars['String']['input'];
  categoryIds: Array<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  imageUrl: Scalars['String']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
  rssFeedLink?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateUserInput = {
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  roles: Array<RoleInput>;
};

export type UploadSubtitlesInput = {
  /** SVP asset id */
  assetId: Scalars['Int']['input'];
  /** Language code from ISO 639-1 */
  languageCode: Scalars['String']['input'];
  /** SVP provider */
  provider: Scalars['String']['input'];
  /** URL to the source of the subtitles */
  source: Scalars['String']['input'];
};

export type UploadSubtitlesOutput = {
  __typename?: 'UploadSubtitlesOutput';
  /** Absolute URL to uploaded subtitles */
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  roles: Array<RoleOutput>;
};

export type VodStream = {
  __typename?: 'VodStream';
  originUrl: Scalars['String']['output'];
  streamingFormats: VodStreamingFormats;
};

export type VodStreamingFormats = {
  __typename?: 'VodStreamingFormats';
  dd: Scalars['String']['output'];
  hls: Scalars['String']['output'];
};

export type WeakCutRange = {
  begin: Scalars['Float']['input'];
  end?: InputMaybe<Scalars['Float']['input']>;
};

export type GetAssetHistoryQueryVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type GetAssetHistoryQuery = { __typename?: 'Query', assetHistory: Array<any> };

export type AuthorDataFieldsFragment = { __typename?: 'Author', title?: string | null, slug?: string | null, id?: string | null, contact?: Array<{ __typename?: 'ContactEntry', type?: string | null, value?: string | null }> | null };

export type TagDataFieldsFragment = { __typename?: 'Tag', id: string, title: string, type: string };

export type StoryDataFieldsFragment = { __typename?: 'Story', id: string, title: string };

export type SearchAuthorsQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchAuthorsQuery = { __typename?: 'Query', searchAuthors: Array<{ __typename?: 'Author', title?: string | null, slug?: string | null, id?: string | null, contact?: Array<{ __typename?: 'ContactEntry', type?: string | null, value?: string | null }> | null }> };

export type GetAuthorsQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  query: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAuthorsQuery = { __typename?: 'Query', getAuthors: Array<{ __typename?: 'Author', title?: string | null, slug?: string | null, id?: string | null, contact?: Array<{ __typename?: 'ContactEntry', type?: string | null, value?: string | null }> | null }> };

export type SearchTagsQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  query: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchTagsQuery = { __typename?: 'Query', searchTags: Array<{ __typename?: 'Tag', id: string, title: string, type: string }> };

export type SuggestTagsQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  subtitlesUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestTagsQuery = { __typename?: 'Query', suggestTags: Array<{ __typename?: 'Tag', id: string, title: string, type: string }> };

export type ListTagsQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListTagsQuery = { __typename?: 'Query', listTags: Array<{ __typename?: 'Tag', id: string, title: string, type: string }> };

export type GetStoriesQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetStoriesQuery = { __typename?: 'Query', getStories: Array<{ __typename?: 'Story', id: string, title: string }> };

export type SearchStoriesQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  query: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchStoriesQuery = { __typename?: 'Query', searchStories: Array<{ __typename?: 'Story', id: string, title: string }> };

export type CreateAssetPreviewMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  editedBy: Scalars['String']['input'];
  cutRange: CutRange;
  artifacts: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateAssetPreviewMutation = { __typename?: 'Mutation', createAssetPreview: { __typename?: 'PreviewErrorResponse', result: boolean, message: string } | { __typename?: 'PreviewSuccessResponse', result: boolean } };

export type UploadAssetPreviewMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  editedBy: Scalars['String']['input'];
  source: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  artifacts: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UploadAssetPreviewMutation = { __typename?: 'Mutation', uploadAssetPreview: { __typename?: 'PreviewErrorResponse', result: boolean, message: string } | { __typename?: 'PreviewSuccessResponse', result: boolean } };

export type UploadCategoryPreviewMutationVariables = Exact<{
  categoryId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  editedBy: Scalars['String']['input'];
  source: Scalars['String']['input'];
  artifacts: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UploadCategoryPreviewMutation = { __typename?: 'Mutation', uploadCategoryPreview: { __typename?: 'PreviewErrorResponse', message: string, result: boolean } | { __typename?: 'PreviewSuccessResponse', result: boolean } };

type LastAssetIngestFragment_AssetIngestDone_Fragment = { __typename: 'AssetIngestDone', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null };

type LastAssetIngestFragment_AssetIngestFailed_Fragment = { __typename: 'AssetIngestFailed', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null };

type LastAssetIngestFragment_AssetIngestInProgress_Fragment = { __typename: 'AssetIngestInProgress', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null, totalProgress?: number | null };

type LastAssetIngestFragment_AssetIngestNone_Fragment = { __typename: 'AssetIngestNone', assetId?: number | null, provider?: string | null };

export type LastAssetIngestFragmentFragment = LastAssetIngestFragment_AssetIngestDone_Fragment | LastAssetIngestFragment_AssetIngestFailed_Fragment | LastAssetIngestFragment_AssetIngestInProgress_Fragment | LastAssetIngestFragment_AssetIngestNone_Fragment;

export type GetLastAssetIngestQueryVariables = Exact<{
  assetCriteria: AssetCriteria;
}>;


export type GetLastAssetIngestQuery = { __typename?: 'Query', lastAssetIngest?: { __typename: 'AssetIngestDone', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null } | { __typename: 'AssetIngestFailed', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null } | { __typename: 'AssetIngestInProgress', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null, totalProgress?: number | null } | { __typename: 'AssetIngestNone', assetId?: number | null, provider?: string | null } | null };

export type GetLastAssetsIngestQueryVariables = Exact<{
  assetsCriteria: Array<AssetCriteria> | AssetCriteria;
}>;


export type GetLastAssetsIngestQuery = { __typename?: 'Query', lastAssetsIngest?: Array<{ __typename: 'AssetIngestDone', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null } | { __typename: 'AssetIngestFailed', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null } | { __typename: 'AssetIngestInProgress', assetId?: number | null, provider?: string | null, type?: AssetIngestType | null, totalProgress?: number | null } | { __typename: 'AssetIngestNone', assetId?: number | null, provider?: string | null } | null> | null };

export type GetLiveEncodersQueryVariables = Exact<{
  newsroom: Scalars['String']['input'];
}>;


export type GetLiveEncodersQuery = { __typename?: 'Query', encoders: Array<{ __typename?: 'LiveEncoder', id: string, name: string, url: string, inputs: Array<{ __typename?: 'ElementalInput', id: number, name?: string | null, event?: { __typename?: 'LiveEvent', id: number, status: LiveEventStatus, schedule?: { __typename?: 'Schedule', startTime?: number | null, endTime?: number | null } | null, asset?: { __typename?: 'Asset', id: number, provider: string } | null } | null }>, events: Array<{ __typename?: 'LiveEvent', id: number, createTime: number, status: LiveEventStatus, networkInputUri?: string | null, hasLivePreview?: boolean | null, schedule?: { __typename?: 'Schedule', startTime?: number | null, endTime?: number | null } | null, encoder?: { __typename?: 'LiveEncoder', id: string, name: string } | null, input?: { __typename?: 'ElementalInput', id: number, name?: string | null } | null, asset?: { __typename?: 'Asset', id: number, provider: string, additional: { __typename?: 'AssetAdditional', metadata?: any | null } } | null, notifications: Array<{ __typename?: 'LiveEventNotification', timestamp: string, level: LiveEventNotificationLevel, message: string, code: number }> }> }>, channels: Array<{ __typename?: 'MediaLiveChannel', id: number, state: MediaLiveChannelState, input: { __typename?: 'MediaLiveInput', type: MediaLiveInputType, urls: Array<string> }, asset: { __typename?: 'AssetIdProvider', id: number, provider: string }, schedule?: { __typename?: 'Schedule', startTime?: number | null, endTime?: number | null } | null }> };

export type GetMediaLiveInputsQueryVariables = Exact<{
  newsroom: Scalars['String']['input'];
  reserved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMediaLiveInputsQuery = { __typename?: 'Query', mediaLiveInputs: Array<{ __typename?: 'MediaLiveInput', id: string, name: string, type: MediaLiveInputType, urls: Array<string>, channel?: { __typename?: 'MediaLiveChannel', asset: { __typename?: 'AssetIdProvider', id: number, provider: string } } | null }> };

export type GetCuttingroomChannelsQueryVariables = Exact<{
  newsroom: Scalars['String']['input'];
}>;


export type GetCuttingroomChannelsQuery = { __typename?: 'Query', cuttingroomChannels: Array<{ __typename?: 'CuttingroomChannel', name: string, server: string, streamKey: string }> };

export type LiveArchiveQueryVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type LiveArchiveQuery = { __typename?: 'Query', liveArchive?: { __typename?: 'LiveArchiveOutput', logoUrl?: string | null } | null };

export type CreateLiveStreamMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  metadata: CreateLiveStreamMetadataInput;
  schedule?: InputMaybe<LiveStreamScheduleInput>;
  livePreview?: InputMaybe<Scalars['Boolean']['input']>;
  liveArchive?: InputMaybe<Scalars['Boolean']['input']>;
  vertical?: InputMaybe<Scalars['Boolean']['input']>;
  setup: LiveStreamSetupInput;
  overlay?: InputMaybe<LiveStreamOverlayInput>;
  deinterlace?: InputMaybe<Scalars['Boolean']['input']>;
  audioNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateLiveStreamMutation = { __typename?: 'Mutation', createLiveStream: { __typename?: 'CreateLiveStreamOutput', asset: { __typename?: 'Asset', id: number, provider: string } } };

export type PrepareLiveStreamMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  metadata?: InputMaybe<PrepareLiveStreamMetadataInput>;
  schedule?: InputMaybe<LiveStreamScheduleInput>;
  livePreview?: InputMaybe<Scalars['Boolean']['input']>;
  liveArchive?: InputMaybe<Scalars['Boolean']['input']>;
  vertical?: InputMaybe<Scalars['Boolean']['input']>;
  setup: LiveStreamSetupInput;
  overlay?: InputMaybe<LiveStreamOverlayInput>;
  deinterlace?: InputMaybe<Scalars['Boolean']['input']>;
  audioNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PrepareLiveStreamMutation = { __typename?: 'Mutation', prepareLiveStream: { __typename?: 'PrepareLiveStreamOutput', asset: { __typename?: 'Asset', id: number, provider: string } } };

export type StartLiveStreamMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  editedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartLiveStreamMutation = { __typename?: 'Mutation', startLiveStream: boolean };

export type StopLiveStreamMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  editedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type StopLiveStreamMutation = { __typename?: 'Mutation', stopLiveStream: boolean };

export type UpdateLiveStreamMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  schedule?: InputMaybe<LiveStreamScheduleInput>;
  metadata: UpdateLiveStreamMetadataInput;
}>;


export type UpdateLiveStreamMutation = { __typename?: 'Mutation', updateLiveStream: boolean };

export type InsertAdMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertAdMutation = { __typename?: 'Mutation', insertAd: boolean };

export type CancelAdMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type CancelAdMutation = { __typename?: 'Mutation', cancelAd: boolean };

export type UnpublishLiveAssetMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  editedBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnpublishLiveAssetMutation = { __typename?: 'Mutation', unpublishLiveAsset: boolean };

export type EncoderInputPreviewQueryVariables = Exact<{
  encoderId: Scalars['String']['input'];
  inputId: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
}>;


export type EncoderInputPreviewQuery = { __typename?: 'Query', encoderInputPreview: { __typename?: 'EncoderInputPreview', base64: string } };

export type GetLiveQueryVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type GetLiveQuery = { __typename?: 'Query', live: { __typename: 'ElementalLive', events: Array<{ __typename: 'ElementalNetworkEvent', dvrLength?: number | null, hasLivePreview: boolean } | { __typename: 'ElementalSdiEvent', dvrLength?: number | null, hasLivePreview: boolean }> } | { __typename: 'ExternalLive', externalUrl: string } | { __typename: 'MediaLiveLive' } | { __typename: 'RtmpLive', streamKey: string } };

export type CreateRtmpPushMutationVariables = Exact<{
  metadata: CreateLiveStreamMetadataInput;
  newsroom: Scalars['String']['input'];
  streamKey: Scalars['String']['input'];
  streamType: RtmpStreamTypeInput;
}>;


export type CreateRtmpPushMutation = { __typename?: 'Mutation', createRtmpPush: { __typename?: 'CreateRtmpPushOutput', asset: { __typename?: 'Asset', id: number, provider: string } } };

export type PrepareRtmpPushMutationVariables = Exact<{
  metadata: PrepareLiveStreamMetadataInput;
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  streamKey: Scalars['String']['input'];
  streamType: RtmpStreamTypeInput;
}>;


export type PrepareRtmpPushMutation = { __typename?: 'Mutation', prepareRtmpPush: { __typename?: 'PrepareRtmpPushOutput', asset: { __typename?: 'Asset', id: number, provider: string } } };

export type DuplicateLiveStreamMutationVariables = Exact<{
  newsroom: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  duplicatedBy: Scalars['String']['input'];
}>;


export type DuplicateLiveStreamMutation = { __typename?: 'Mutation', duplicateLiveStream: { __typename?: 'DuplicateLiveStreamOutput', asset: { __typename?: 'Asset', id: number, provider: string } } };

export type ChangeAssetRestrictionsMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  geoRestriction?: InputMaybe<GeoRestriction>;
  accessLevel?: InputMaybe<AccessLevel>;
}>;


export type ChangeAssetRestrictionsMutation = { __typename?: 'Mutation', changeAssetRestrictions: boolean };

export type UploadSubtitlesMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  languageCode: Scalars['String']['input'];
  source: Scalars['String']['input'];
}>;


export type UploadSubtitlesMutation = { __typename?: 'Mutation', uploadSubtitles: { __typename?: 'UploadSubtitlesOutput', url: string } };

export type StreamDurationQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type StreamDurationQuery = { __typename?: 'Query', streamDuration?: number | null };

export type SignAssetStreamUrlsMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  expirationTime: Scalars['Int']['input'];
}>;


export type SignAssetStreamUrlsMutation = { __typename?: 'Mutation', signAssetStreamUrls: Array<{ __typename?: 'StreamUrl', format: StreamUrlFormat, url: string }> };

export type PlaylistFragment = { __typename?: 'StreamPlaylist', id: string, name: string, provider: string, header?: string | null, searchQuery?: string | null, locked: boolean, metadata?: any | null, labels: Array<{ __typename?: 'PlaylistLabel', id: string, name: string, type: string }>, items: Array<{ __typename?: 'PositionedPlaylistAsset', position: number, asset: { __typename?: 'PlaylistAsset', id: number, provider: string } } | { __typename?: 'PositionedPlaylistItemPlaylist', position: number, playlist: { __typename?: 'PlaylistItemPlaylist', id: string, provider: string } }> };

export type GetPlaylistsQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  labels?: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPlaylistsQuery = { __typename?: 'Query', providerPlaylists: Array<{ __typename?: 'StreamPlaylist', id: string, name: string, provider: string, header?: string | null, searchQuery?: string | null, locked: boolean, metadata?: any | null, labels: Array<{ __typename?: 'PlaylistLabel', id: string, name: string, type: string }>, items: Array<{ __typename?: 'PositionedPlaylistAsset', position: number, asset: { __typename?: 'PlaylistAsset', id: number, provider: string } } | { __typename?: 'PositionedPlaylistItemPlaylist', position: number, playlist: { __typename?: 'PlaylistItemPlaylist', id: string, provider: string } }> }> };

export type CreatePlaylistMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  name: Scalars['String']['input'];
  header?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<PlaylistLabelInput> | PlaylistLabelInput>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  items: Array<PlaylistItemInput> | PlaylistItemInput;
}>;


export type CreatePlaylistMutation = { __typename?: 'Mutation', createPlaylist: { __typename?: 'CreatePlaylistResponse', success: boolean, errors?: Array<string> | null, playlist?: { __typename?: 'StreamPlaylist', id: string, name: string, provider: string, header?: string | null, searchQuery?: string | null, locked: boolean, metadata?: any | null, labels: Array<{ __typename?: 'PlaylistLabel', id: string, name: string, type: string }>, items: Array<{ __typename?: 'PositionedPlaylistAsset', position: number, asset: { __typename?: 'PlaylistAsset', id: number, provider: string } } | { __typename?: 'PositionedPlaylistItemPlaylist', position: number, playlist: { __typename?: 'PlaylistItemPlaylist', id: string, provider: string } }> } | null } };

export type UpdatePlaylistMutationVariables = Exact<{
  id: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  name: Scalars['String']['input'];
  header?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<PlaylistLabelInput> | PlaylistLabelInput>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  items: Array<PlaylistItemInput> | PlaylistItemInput;
}>;


export type UpdatePlaylistMutation = { __typename?: 'Mutation', updatePlaylist: { __typename?: 'UpdatePlaylistResponse', success: boolean, errors?: Array<string> | null, playlist?: { __typename?: 'StreamPlaylist', id: string, name: string, provider: string, header?: string | null, searchQuery?: string | null, locked: boolean, metadata?: any | null, labels: Array<{ __typename?: 'PlaylistLabel', id: string, name: string, type: string }>, items: Array<{ __typename?: 'PositionedPlaylistAsset', position: number, asset: { __typename?: 'PlaylistAsset', id: number, provider: string } } | { __typename?: 'PositionedPlaylistItemPlaylist', position: number, playlist: { __typename?: 'PlaylistItemPlaylist', id: string, provider: string } }> } | null } };

export type DeletePlaylistMutationVariables = Exact<{
  id: Scalars['String']['input'];
  provider: Scalars['String']['input'];
}>;


export type DeletePlaylistMutation = { __typename?: 'Mutation', deletePlaylist: { __typename?: 'DeletePlaylistResponse', success: boolean, playlist?: { __typename?: 'StreamPlaylist', id: string, items: Array<{ __typename?: 'PositionedPlaylistAsset', position: number, asset: { __typename?: 'PlaylistAsset', id: number, provider: string } } | { __typename?: 'PositionedPlaylistItemPlaylist', position: number, playlist: { __typename?: 'PlaylistItemPlaylist', id: string, provider: string } }> } | null } };

export type PodmeCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PodmeCategoriesQuery = { __typename?: 'Query', podmeCategories: Array<{ __typename?: 'PodmeCategory', id: number, name?: string | null }> };

export type AssetPodmeMetadataQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type AssetPodmeMetadataQuery = { __typename?: 'Query', assetPodmeMetadata: { __typename?: 'AssetPodmeMetadata', sendToPodme: boolean, podmeId?: number | null } };

export type CategoryPodmeMetadataQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
}>;


export type CategoryPodmeMetadataQuery = { __typename?: 'Query', categoryPodmeMetadata: { __typename?: 'CategoryPodmeMetadata', sendToPodme: boolean, podmeId?: number | null, podmeCategories: Array<number>, sendRssToPodme: boolean } };

export type ModifyAssetPodmeMetadataMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  metadata: AssetPodmeMetadataInput;
}>;


export type ModifyAssetPodmeMetadataMutation = { __typename?: 'Mutation', modifyAssetPodmeMetadata: { __typename?: 'AssetPodmeMetadata', sendToPodme: boolean, podmeId?: number | null } };

export type ModifyCategoryPodmeMetadataMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  metadata: CategoryPodmeMetadataInput;
}>;


export type ModifyCategoryPodmeMetadataMutation = { __typename?: 'Mutation', modifyCategoryPodmeMetadata: { __typename?: 'CategoryPodmeMetadata', sendToPodme: boolean, podmeId?: number | null, podmeCategories: Array<number>, sendRssToPodme: boolean } };

export type SendPushNotificationMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  notificationBody?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendPushNotificationMutation = { __typename?: 'Mutation', sendPushNotification?: { __typename: 'SendPushNotificationErrorResponse', errorMessage: string } | { __typename: 'SendPushNotificationSuccessResponse', pushIds: Array<string>, numRecipients: number } | null };

export type GetAssetSchedulesQueryVariables = Exact<{
  provider?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['Int']['input']>;
  action: AssetScheduleActions;
}>;


export type GetAssetSchedulesQuery = { __typename?: 'Query', assetSchedules?: Array<{ __typename?: 'AssetSchedule', provider: string, assetId: number, time: number, action: AssetScheduleActions }> | null };

export type CreateAssetScheduleMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  time: Scalars['Int']['input'];
  action: AssetScheduleActions;
}>;


export type CreateAssetScheduleMutation = { __typename?: 'Mutation', createAssetSchedule?: { __typename?: 'AssetSchedule', provider: string, assetId: number, time: number, action: AssetScheduleActions } | null };

export type UpdateAssetScheduleMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  time: Scalars['Int']['input'];
  action: AssetScheduleActions;
}>;


export type UpdateAssetScheduleMutation = { __typename?: 'Mutation', updateAssetSchedule?: { __typename?: 'AssetSchedule', provider: string, assetId: number, time: number, action: AssetScheduleActions } | null };

export type DeleteAssetScheduleMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  action: AssetScheduleActions;
}>;


export type DeleteAssetScheduleMutation = { __typename?: 'Mutation', deleteAssetSchedule?: boolean | null };

export type GetNotificationSchedulesQueryVariables = Exact<{
  provider?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['Int']['input']>;
  action: NotificationScheduleActions;
}>;


export type GetNotificationSchedulesQuery = { __typename?: 'Query', notificationSchedules?: Array<{ __typename?: 'NotificationSchedule', provider: string, assetId: number, action: NotificationScheduleActions, time: number, notificationBody?: string | null, notificationData?: { __typename?: 'NotificationData', owner: string, importance: number, items: Array<{ __typename?: 'NotificationDataItem', type: string, namespace: string, context?: string | null, id: string }>, push: { __typename?: 'NotificationDataPush', title?: string | null, body: string, target: string, excludedTopics?: Array<string> | null } } | null }> | null };

export type CreateNotificationScheduleMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  action: NotificationScheduleActions;
  time: Scalars['Int']['input'];
  notificationBody?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateNotificationScheduleMutation = { __typename?: 'Mutation', createNotificationSchedule?: { __typename?: 'NotificationSchedule', provider: string, assetId: number, action: NotificationScheduleActions, time: number, notificationBody?: string | null, notificationData?: { __typename?: 'NotificationData', owner: string, importance: number, items: Array<{ __typename?: 'NotificationDataItem', type: string, namespace: string, context?: string | null, id: string }>, push: { __typename?: 'NotificationDataPush', title?: string | null, body: string, target: string, excludedTopics?: Array<string> | null } } | null } | null };

export type UpdateNotificationScheduleMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  action: NotificationScheduleActions;
  time: Scalars['Int']['input'];
  notificationBody?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNotificationScheduleMutation = { __typename?: 'Mutation', updateNotificationSchedule?: { __typename?: 'NotificationSchedule', provider: string, assetId: number, action: NotificationScheduleActions, time: number, notificationBody?: string | null, notificationData?: { __typename?: 'NotificationData', owner: string, importance: number, items: Array<{ __typename?: 'NotificationDataItem', type: string, namespace: string, context?: string | null, id: string }>, push: { __typename?: 'NotificationDataPush', title?: string | null, body: string, target: string, excludedTopics?: Array<string> | null } } | null } | null };

export type DeleteNotificationScheduleMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  action: NotificationScheduleActions;
}>;


export type DeleteNotificationScheduleMutation = { __typename?: 'Mutation', deleteNotificationSchedule?: boolean | null };

export type NotificationDataFieldsFragment = { __typename?: 'NotificationData', owner: string, importance: number, items: Array<{ __typename?: 'NotificationDataItem', type: string, namespace: string, context?: string | null, id: string }>, push: { __typename?: 'NotificationDataPush', title?: string | null, body: string, target: string, excludedTopics?: Array<string> | null } };

export type GetEngagementStatsApiKeyQueryVariables = Exact<{
  provider: Scalars['String']['input'];
}>;


export type GetEngagementStatsApiKeyQuery = { __typename?: 'Query', getEngagementStatsApiKey: { __typename?: 'StatsApiKey', value?: string | null } };

export type GenerateSubtitlesForAssetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
}>;


export type GenerateSubtitlesForAssetMutation = { __typename?: 'Mutation', generateSubtitlesForAsset?: { __typename?: 'GenerateSubtitlesForAssetOutput', success?: boolean | null, error?: string | null } | null };

export type GetDurationFromUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type GetDurationFromUrlQuery = { __typename?: 'Query', playlists: Array<{ __typename?: 'Playlist', duration: number }> };

export type ConvertVideoMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type ConvertVideoMutation = { __typename?: 'Mutation', convertVideo: { __typename?: 'ConvertVideoOutput', url: string } };

export type PrepareLiveArchiveMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  cutRange?: InputMaybe<LiveArchiveCutRangeInput>;
}>;


export type PrepareLiveArchiveMutation = { __typename?: 'Mutation', prepareLiveArchive: { __typename?: 'PrepareLiveArchiveOutput', url?: string | null } };

export type CropLiveArchiveMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
  cutRange: LiveArchiveCutRangeInput;
  createdBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CropLiveArchiveMutation = { __typename?: 'Mutation', cropLiveArchive: { __typename?: 'CropLiveArchiveOutput', assetId?: number | null, originAssetId?: number | null } };

export type LiveArchiveExpirationQueryVariables = Exact<{
  provider: Scalars['String']['input'];
  assetId: Scalars['Int']['input'];
}>;


export type LiveArchiveExpirationQuery = { __typename?: 'Query', liveArchiveExpiration?: number | null };

export type CreateUserMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  roles: Array<RoleInput> | RoleInput;
  created: Scalars['DateTime']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'ManageUserFailure', message: string } | { __typename?: 'User', email: string, firstname?: string | null, lastname?: string | null, roles: Array<{ __typename?: 'RoleOutput', newsroom: string, roleType: string }> } | null };

export type UpdateUserMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  roles: Array<RoleInput> | RoleInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'ManageUserFailure', message: string } | { __typename?: 'User', email: string, firstname?: string | null, lastname?: string | null, roles: Array<{ __typename?: 'RoleOutput', newsroom: string, roleType: string }> } | null };

export type GetUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', email: string, firstname?: string | null, lastname?: string | null, roles: Array<{ __typename?: 'RoleOutput', newsroom: string, roleType: string }> }> };

export type CreateClipsMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  cutRanges: Array<WeakCutRange> | WeakCutRange;
}>;


export type CreateClipsMutation = { __typename?: 'Mutation', createClips: { __typename?: 'CreateClipsSuccessResponse', assetId: number, originAssetId: number } | { __typename?: 'ErrorResponse', message: string } };

export type TrimAssetMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  cutRanges: Array<WeakCutRange> | WeakCutRange;
}>;


export type TrimAssetMutation = { __typename?: 'Mutation', trimAsset: boolean };

export type TranscodeVideoMutationVariables = Exact<{
  assetId: Scalars['Int']['input'];
  newsroom: Scalars['String']['input'];
  sourceUri: Scalars['String']['input'];
  options?: InputMaybe<TranscodeVideoOptions>;
}>;


export type TranscodeVideoMutation = { __typename?: 'Mutation', transcodeVideo: { __typename?: 'TranscodeVideoResponse', assetId: number, requestId: string } };

export const AuthorDataFieldsFragmentDoc = `
    fragment authorDataFields on Author {
  title
  slug
  id
  contact {
    type
    value
  }
}
    `;
export const TagDataFieldsFragmentDoc = `
    fragment tagDataFields on Tag {
  id
  title
  type
}
    `;
export const StoryDataFieldsFragmentDoc = `
    fragment storyDataFields on Story {
  id
  title
}
    `;
export const LastAssetIngestFragmentFragmentDoc = `
    fragment lastAssetIngestFragment on LastAssetIngest {
  __typename
  ... on AssetIngestNone {
    assetId
    provider
  }
  ... on AssetIngest {
    assetId
    provider
    type
  }
  ... on AssetIngestInProgress {
    totalProgress
  }
}
    `;
export const PlaylistFragmentDoc = `
    fragment Playlist on StreamPlaylist {
  id
  name
  provider
  header
  labels {
    id
    name
    type
  }
  searchQuery
  locked
  metadata
  items {
    ... on PositionedPlaylistAsset {
      position
      asset {
        id
        provider
      }
    }
    ... on PositionedPlaylistItemPlaylist {
      position
      playlist {
        id
        provider
      }
    }
  }
}
    `;
export const NotificationDataFieldsFragmentDoc = `
    fragment notificationDataFields on NotificationData {
  owner
  importance
  items {
    type
    namespace
    context
    id
  }
  push {
    title
    body
    target
    excludedTopics
  }
}
    `;
export const GetAssetHistoryDocument = `
    query GetAssetHistory($newsroom: String!, $assetId: Int!) {
  assetHistory(newsroom: $newsroom, assetId: $assetId)
}
    `;
export const SearchAuthorsDocument = `
    query searchAuthors($provider: String!, $query: String!) {
  searchAuthors(provider: $provider, query: $query) {
    ...authorDataFields
  }
}
    ${AuthorDataFieldsFragmentDoc}`;
export const GetAuthorsDocument = `
    query getAuthors($provider: String!, $query: [String!]!) {
  getAuthors(provider: $provider, ids: $query) {
    ...authorDataFields
  }
}
    ${AuthorDataFieldsFragmentDoc}`;
export const SearchTagsDocument = `
    query searchTags($provider: String!, $query: String!, $page: Int, $limit: Int) {
  searchTags(provider: $provider, query: $query, page: $page, limit: $limit) {
    ...tagDataFields
  }
}
    ${TagDataFieldsFragmentDoc}`;
export const SuggestTagsDocument = `
    query suggestTags($provider: String!, $title: String!, $description: String, $tags: [String!], $subtitlesUrls: [String!], $limit: Int) {
  suggestTags(
    provider: $provider
    title: $title
    description: $description
    tags: $tags
    subtitlesUrls: $subtitlesUrls
    limit: $limit
  ) {
    ...tagDataFields
  }
}
    ${TagDataFieldsFragmentDoc}`;
export const ListTagsDocument = `
    query listTags($provider: String!, $ids: [String!]!) {
  listTags(provider: $provider, ids: $ids) {
    ...tagDataFields
  }
}
    ${TagDataFieldsFragmentDoc}`;
export const GetStoriesDocument = `
    query getStories($provider: String!, $ids: [String!]!) {
  getStories(provider: $provider, ids: $ids) {
    ...storyDataFields
  }
}
    ${StoryDataFieldsFragmentDoc}`;
export const SearchStoriesDocument = `
    query searchStories($provider: String!, $query: String!, $page: Int, $limit: Int) {
  searchStories(provider: $provider, query: $query, page: $page, limit: $limit) {
    ...storyDataFields
  }
}
    ${StoryDataFieldsFragmentDoc}`;
export const CreateAssetPreviewDocument = `
    mutation createAssetPreview($assetId: Int!, $provider: String!, $editedBy: String!, $cutRange: CutRange!, $artifacts: [String!]!) {
  createAssetPreview(
    assetId: $assetId
    provider: $provider
    editedBy: $editedBy
    cutRange: $cutRange
    artifacts: $artifacts
  ) {
    ... on PreviewSuccessResponse {
      result
    }
    ... on PreviewErrorResponse {
      result
      message
    }
  }
}
    `;
export const UploadAssetPreviewDocument = `
    mutation uploadAssetPreview($assetId: Int!, $provider: String!, $editedBy: String!, $source: String!, $prefix: String, $artifacts: [String!]!) {
  uploadAssetPreview(
    assetId: $assetId
    provider: $provider
    editedBy: $editedBy
    source: $source
    prefix: $prefix
    artifacts: $artifacts
  ) {
    ... on PreviewSuccessResponse {
      result
    }
    ... on PreviewErrorResponse {
      result
      message
    }
  }
}
    `;
export const UploadCategoryPreviewDocument = `
    mutation uploadCategoryPreview($categoryId: Int!, $provider: String!, $editedBy: String!, $source: String!, $artifacts: [String!]!) {
  uploadCategoryPreview(
    categoryId: $categoryId
    provider: $provider
    editedBy: $editedBy
    source: $source
    artifacts: $artifacts
  ) {
    ... on PreviewSuccessResponse {
      result
    }
    ... on PreviewErrorResponse {
      message
      result
    }
  }
}
    `;
export const GetLastAssetIngestDocument = `
    query getLastAssetIngest($assetCriteria: AssetCriteria!) {
  lastAssetIngest(assetCriteria: $assetCriteria) {
    ...lastAssetIngestFragment
  }
}
    ${LastAssetIngestFragmentFragmentDoc}`;
export const GetLastAssetsIngestDocument = `
    query getLastAssetsIngest($assetsCriteria: [AssetCriteria!]!) {
  lastAssetsIngest(assetsCriteria: $assetsCriteria) {
    ...lastAssetIngestFragment
  }
}
    ${LastAssetIngestFragmentFragmentDoc}`;
export const GetLiveEncodersDocument = `
    query GetLiveEncoders($newsroom: String!) {
  encoders(newsroom: $newsroom) {
    id
    name
    url
    inputs {
      id
      name
      event {
        id
        schedule {
          startTime
          endTime
        }
        status
        asset {
          id
          provider
        }
      }
    }
    events(newsroom: $newsroom) {
      id
      createTime
      schedule {
        startTime
        endTime
      }
      status
      encoder {
        id
        name
      }
      input {
        id
        name
      }
      asset {
        id
        provider
        additional {
          metadata
        }
      }
      notifications {
        timestamp
        level
        message
        code
      }
      networkInputUri
      hasLivePreview
    }
  }
  channels: mediaLiveChannels(newsroom: $newsroom) {
    id
    state
    input {
      type
      urls
    }
    asset {
      id
      provider
    }
    schedule {
      startTime
      endTime
    }
  }
}
    `;
export const GetMediaLiveInputsDocument = `
    query GetMediaLiveInputs($newsroom: String!, $reserved: Boolean = true) {
  mediaLiveInputs(where: {newsroom: $newsroom, reserved: $reserved}) {
    id
    name
    type
    urls
    channel {
      asset {
        id
        provider
      }
    }
  }
}
    `;
export const GetCuttingroomChannelsDocument = `
    query GetCuttingroomChannels($newsroom: String!) {
  cuttingroomChannels(newsroom: $newsroom) {
    name
    server
    streamKey
  }
}
    `;
export const LiveArchiveDocument = `
    query LiveArchive($newsroom: String!, $assetId: Int!) {
  liveArchive(newsroom: $newsroom, assetId: $assetId) {
    logoUrl
  }
}
    `;
export const CreateLiveStreamDocument = `
    mutation CreateLiveStream($newsroom: String!, $metadata: CreateLiveStreamMetadataInput!, $schedule: LiveStreamScheduleInput, $livePreview: Boolean, $liveArchive: Boolean, $vertical: Boolean, $setup: LiveStreamSetupInput!, $overlay: LiveStreamOverlayInput, $deinterlace: Boolean, $audioNormalization: Boolean, $audioOnly: Boolean) {
  createLiveStream(
    input: {newsroom: $newsroom, metadata: $metadata, schedule: $schedule, livePreview: $livePreview, liveArchive: $liveArchive, vertical: $vertical, setup: $setup, overlay: $overlay, deinterlace: $deinterlace, audioNormalization: $audioNormalization, audioOnly: $audioOnly}
  ) {
    asset {
      id
      provider
    }
  }
}
    `;
export const PrepareLiveStreamDocument = `
    mutation prepareLiveStream($newsroom: String!, $assetId: Int!, $metadata: PrepareLiveStreamMetadataInput, $schedule: LiveStreamScheduleInput, $livePreview: Boolean, $liveArchive: Boolean, $vertical: Boolean, $setup: LiveStreamSetupInput!, $overlay: LiveStreamOverlayInput, $deinterlace: Boolean, $audioNormalization: Boolean, $audioOnly: Boolean) {
  prepareLiveStream(
    input: {newsroom: $newsroom, assetId: $assetId, metadata: $metadata, schedule: $schedule, livePreview: $livePreview, liveArchive: $liveArchive, vertical: $vertical, setup: $setup, overlay: $overlay, deinterlace: $deinterlace, audioNormalization: $audioNormalization, audioOnly: $audioOnly}
  ) {
    asset {
      id
      provider
    }
  }
}
    `;
export const StartLiveStreamDocument = `
    mutation StartLiveStream($newsroom: String!, $assetId: Int!, $editedBy: String) {
  startLiveStream(
    input: {newsroom: $newsroom, assetId: $assetId, editedBy: $editedBy}
  )
}
    `;
export const StopLiveStreamDocument = `
    mutation StopLiveStream($newsroom: String!, $assetId: Int!, $editedBy: String) {
  stopLiveStream(
    input: {newsroom: $newsroom, assetId: $assetId, editedBy: $editedBy}
  )
}
    `;
export const UpdateLiveStreamDocument = `
    mutation UpdateLiveStream($newsroom: String!, $assetId: Int!, $schedule: LiveStreamScheduleInput, $metadata: UpdateLiveStreamMetadataInput!) {
  updateLiveStream(
    input: {newsroom: $newsroom, assetId: $assetId, schedule: $schedule, metadata: $metadata}
  )
}
    `;
export const InsertAdDocument = `
    mutation InsertAd($newsroom: String!, $assetId: Int!, $duration: Int!, $offset: Int) {
  insertAd(
    input: {newsroom: $newsroom, assetId: $assetId, duration: $duration, offset: $offset}
  )
}
    `;
export const CancelAdDocument = `
    mutation CancelAd($newsroom: String!, $assetId: Int!) {
  cancelAd(input: {newsroom: $newsroom, assetId: $assetId})
}
    `;
export const UnpublishLiveAssetDocument = `
    mutation UnpublishLiveAsset($newsroom: String!, $assetId: Int!, $editedBy: String) {
  unpublishLiveAsset(
    input: {newsroom: $newsroom, assetId: $assetId, editedBy: $editedBy}
  )
}
    `;
export const EncoderInputPreviewDocument = `
    query EncoderInputPreview($encoderId: String!, $inputId: Int!, $width: Int!, $height: Int!) {
  encoderInputPreview(
    input: {sdi: {encoderId: $encoderId, inputId: $inputId}, size: {width: $width, height: $height}}
  ) {
    base64
  }
}
    `;
export const GetLiveDocument = `
    query getLive($newsroom: String!, $assetId: Int!) {
  live(input: {newsroom: $newsroom, assetId: $assetId}) {
    __typename
    ... on ElementalLive {
      events {
        __typename
        ... on ElementalLiveEvent {
          dvrLength
          hasLivePreview
        }
      }
    }
    ... on ExternalLive {
      externalUrl
    }
    ... on RtmpLive {
      streamKey
    }
  }
}
    `;
export const CreateRtmpPushDocument = `
    mutation createRtmpPush($metadata: CreateLiveStreamMetadataInput!, $newsroom: String!, $streamKey: String!, $streamType: RtmpStreamTypeInput!) {
  createRtmpPush(
    input: {metadata: $metadata, newsroom: $newsroom, streamKey: $streamKey, streamType: $streamType}
  ) {
    asset {
      id
      provider
    }
  }
}
    `;
export const PrepareRtmpPushDocument = `
    mutation prepareRtmpPush($metadata: PrepareLiveStreamMetadataInput!, $newsroom: String!, $assetId: Int!, $streamKey: String!, $streamType: RtmpStreamTypeInput!) {
  prepareRtmpPush(
    input: {metadata: $metadata, newsroom: $newsroom, assetId: $assetId, streamKey: $streamKey, streamType: $streamType}
  ) {
    asset {
      id
      provider
    }
  }
}
    `;
export const DuplicateLiveStreamDocument = `
    mutation DuplicateLiveStream($newsroom: String!, $assetId: Int!, $duplicatedBy: String!) {
  duplicateLiveStream(
    input: {newsroom: $newsroom, assetId: $assetId, duplicatedBy: $duplicatedBy}
  ) {
    asset {
      id
      provider
    }
  }
}
    `;
export const ChangeAssetRestrictionsDocument = `
    mutation changeAssetRestrictions($provider: String!, $assetId: Int!, $geoRestriction: GeoRestriction, $accessLevel: AccessLevel) {
  changeAssetRestrictions(
    input: {provider: $provider, assetId: $assetId, geoRestriction: $geoRestriction, accessLevel: $accessLevel}
  )
}
    `;
export const UploadSubtitlesDocument = `
    mutation uploadSubtitles($provider: String!, $assetId: Int!, $languageCode: String!, $source: String!) {
  uploadSubtitles(
    input: {provider: $provider, assetId: $assetId, languageCode: $languageCode, source: $source}
  ) {
    url
  }
}
    `;
export const StreamDurationDocument = `
    query streamDuration($provider: String!, $assetId: Int!) {
  streamDuration(input: {provider: $provider, assetId: $assetId})
}
    `;
export const SignAssetStreamUrlsDocument = `
    mutation signAssetStreamUrls($provider: String!, $assetId: Int!, $expirationTime: Int!) {
  signAssetStreamUrls(
    input: {provider: $provider, assetId: $assetId, expirationTime: $expirationTime}
  ) {
    format
    url
  }
}
    `;
export const GetPlaylistsDocument = `
    query GetPlaylists($provider: String!, $id: String, $name: String, $labels: [String!]! = [], $limit: Int, $page: Int) {
  providerPlaylists(
    filter: {provider: $provider, name: $name, id: $id, labels: $labels}
    limit: $limit
    page: $page
  ) {
    ...Playlist
  }
}
    ${PlaylistFragmentDoc}`;
export const CreatePlaylistDocument = `
    mutation CreatePlaylist($provider: String!, $name: String!, $header: String, $labels: [PlaylistLabelInput!], $searchQuery: String, $metadata: JSON, $items: [PlaylistItemInput!]!) {
  createPlaylist(
    data: {provider: $provider, name: $name, header: $header, labels: $labels, searchQuery: $searchQuery, metadata: $metadata, items: $items}
  ) {
    success
    playlist {
      ...Playlist
    }
    errors
  }
}
    ${PlaylistFragmentDoc}`;
export const UpdatePlaylistDocument = `
    mutation UpdatePlaylist($id: String!, $provider: String!, $name: String!, $header: String, $labels: [PlaylistLabelInput!], $searchQuery: String, $metadata: JSON, $items: [PlaylistItemInput!]!) {
  updatePlaylist(
    data: {id: $id, provider: $provider, name: $name, header: $header, labels: $labels, searchQuery: $searchQuery, metadata: $metadata, items: $items}
  ) {
    success
    playlist {
      ...Playlist
    }
    errors
  }
}
    ${PlaylistFragmentDoc}`;
export const DeletePlaylistDocument = `
    mutation DeletePlaylist($id: String!, $provider: String!) {
  deletePlaylist(data: {id: $id, provider: $provider}) {
    success
    playlist {
      id
      items {
        ... on PositionedPlaylistAsset {
          position
          asset {
            id
            provider
          }
        }
        ... on PositionedPlaylistItemPlaylist {
          position
          playlist {
            id
            provider
          }
        }
      }
    }
  }
}
    `;
export const PodmeCategoriesDocument = `
    query PodmeCategories {
  podmeCategories {
    id
    name
  }
}
    `;
export const AssetPodmeMetadataDocument = `
    query AssetPodmeMetadata($provider: String!, $assetId: Int!) {
  assetPodmeMetadata(where: {provider: $provider, assetId: $assetId}) {
    sendToPodme
    podmeId
  }
}
    `;
export const CategoryPodmeMetadataDocument = `
    query CategoryPodmeMetadata($provider: String!, $categoryId: Int!) {
  categoryPodmeMetadata(where: {provider: $provider, categoryId: $categoryId}) {
    sendToPodme
    podmeId
    podmeCategories
    sendRssToPodme
  }
}
    `;
export const ModifyAssetPodmeMetadataDocument = `
    mutation ModifyAssetPodmeMetadata($provider: String!, $assetId: Int!, $metadata: AssetPodmeMetadataInput!) {
  modifyAssetPodmeMetadata(
    where: {provider: $provider, assetId: $assetId}
    metadata: $metadata
  ) {
    sendToPodme
    podmeId
  }
}
    `;
export const ModifyCategoryPodmeMetadataDocument = `
    mutation ModifyCategoryPodmeMetadata($provider: String!, $categoryId: Int!, $metadata: CategoryPodmeMetadataInput!) {
  modifyCategoryPodmeMetadata(
    where: {provider: $provider, categoryId: $categoryId}
    metadata: $metadata
  ) {
    sendToPodme
    podmeId
    podmeCategories
    sendRssToPodme
  }
}
    `;
export const SendPushNotificationDocument = `
    mutation SendPushNotification($provider: String!, $assetId: Int!, $notificationBody: String) {
  sendPushNotification(
    data: {provider: $provider, assetId: $assetId, notificationBody: $notificationBody}
  ) {
    __typename
    ... on SendPushNotificationSuccessResponse {
      pushIds
      numRecipients
    }
    ... on SendPushNotificationErrorResponse {
      errorMessage
    }
  }
}
    `;
export const GetAssetSchedulesDocument = `
    query GetAssetSchedules($provider: String, $assetId: Int, $action: AssetScheduleActions!) {
  assetSchedules(where: {provider: $provider, assetId: $assetId, action: $action}) {
    provider
    assetId
    time
    action
  }
}
    `;
export const CreateAssetScheduleDocument = `
    mutation CreateAssetSchedule($provider: String!, $assetId: Int!, $time: Int!, $action: AssetScheduleActions!) {
  createAssetSchedule(
    data: {provider: $provider, assetId: $assetId, time: $time, action: $action}
  ) {
    provider
    assetId
    time
    action
  }
}
    `;
export const UpdateAssetScheduleDocument = `
    mutation UpdateAssetSchedule($provider: String!, $assetId: Int!, $time: Int!, $action: AssetScheduleActions!) {
  updateAssetSchedule(
    where: {provider: $provider, assetId: $assetId, action: $action}
    data: {time: $time}
  ) {
    provider
    assetId
    time
    action
  }
}
    `;
export const DeleteAssetScheduleDocument = `
    mutation DeleteAssetSchedule($provider: String!, $assetId: Int!, $action: AssetScheduleActions!) {
  deleteAssetSchedule(
    where: {provider: $provider, assetId: $assetId, action: $action}
  )
}
    `;
export const GetNotificationSchedulesDocument = `
    query GetNotificationSchedules($provider: String, $assetId: Int, $action: NotificationScheduleActions!) {
  notificationSchedules(
    where: {provider: $provider, assetId: $assetId, action: $action}
  ) {
    provider
    assetId
    action
    time
    notificationBody
    notificationData {
      ...notificationDataFields
    }
  }
}
    ${NotificationDataFieldsFragmentDoc}`;
export const CreateNotificationScheduleDocument = `
    mutation CreateNotificationSchedule($provider: String!, $assetId: Int!, $action: NotificationScheduleActions!, $time: Int!, $notificationBody: String) {
  createNotificationSchedule(
    data: {provider: $provider, assetId: $assetId, time: $time, action: $action, notificationBody: $notificationBody}
  ) {
    provider
    assetId
    action
    time
    notificationBody
    notificationData {
      ...notificationDataFields
    }
  }
}
    ${NotificationDataFieldsFragmentDoc}`;
export const UpdateNotificationScheduleDocument = `
    mutation UpdateNotificationSchedule($provider: String!, $assetId: Int!, $action: NotificationScheduleActions!, $time: Int!, $notificationBody: String) {
  updateNotificationSchedule(
    where: {provider: $provider, assetId: $assetId, action: $action}
    data: {time: $time, notificationBody: $notificationBody}
  ) {
    provider
    assetId
    action
    time
    notificationBody
    notificationData {
      ...notificationDataFields
    }
  }
}
    ${NotificationDataFieldsFragmentDoc}`;
export const DeleteNotificationScheduleDocument = `
    mutation DeleteNotificationSchedule($provider: String!, $assetId: Int!, $action: NotificationScheduleActions!) {
  deleteNotificationSchedule(
    where: {provider: $provider, assetId: $assetId, action: $action}
  )
}
    `;
export const GetEngagementStatsApiKeyDocument = `
    query GetEngagementStatsApiKey($provider: String!) {
  getEngagementStatsApiKey(provider: $provider) {
    value
  }
}
    `;
export const GenerateSubtitlesForAssetDocument = `
    mutation GenerateSubtitlesForAsset($id: Int!, $provider: String!) {
  generateSubtitlesForAsset(id: $id, provider: $provider) {
    success
    error
  }
}
    `;
export const GetDurationFromUrlDocument = `
    query getDurationFromUrl($url: String!) {
  playlists(url: $url) {
    duration
  }
}
    `;
export const ConvertVideoDocument = `
    mutation ConvertVideo($provider: String!, $assetId: Int!) {
  convertVideo(input: {provider: $provider, assetId: $assetId}) {
    url
  }
}
    `;
export const PrepareLiveArchiveDocument = `
    mutation PrepareLiveArchive($provider: String!, $assetId: Int!, $cutRange: LiveArchiveCutRangeInput) {
  prepareLiveArchive(
    input: {provider: $provider, assetId: $assetId, cutRange: $cutRange}
  ) {
    url
  }
}
    `;
export const CropLiveArchiveDocument = `
    mutation CropLiveArchive($provider: String!, $assetId: Int!, $cutRange: LiveArchiveCutRangeInput!, $createdBy: String) {
  cropLiveArchive(
    input: {provider: $provider, assetId: $assetId, cutRange: $cutRange, createdBy: $createdBy}
  ) {
    assetId
    originAssetId
  }
}
    `;
export const LiveArchiveExpirationDocument = `
    query LiveArchiveExpiration($provider: String!, $assetId: Int!) {
  liveArchiveExpiration(input: {provider: $provider, assetId: $assetId})
}
    `;
export const CreateUserDocument = `
    mutation CreateUser($firstname: String, $lastname: String, $email: String!, $roles: [RoleInput!]!, $created: DateTime!) {
  createUser(
    data: {firstname: $firstname, lastname: $lastname, email: $email, roles: $roles, created: $created}
  ) {
    ... on User {
      email
      firstname
      lastname
      roles {
        newsroom
        roleType
      }
    }
    ... on ManageUserFailure {
      message
    }
  }
}
    `;
export const UpdateUserDocument = `
    mutation UpdateUser($firstname: String, $lastname: String, $email: String!, $roles: [RoleInput!]!) {
  updateUser(
    data: {firstname: $firstname, lastname: $lastname, email: $email, roles: $roles}
  ) {
    ... on User {
      email
      firstname
      lastname
      roles {
        newsroom
        roleType
      }
    }
    ... on ManageUserFailure {
      message
    }
  }
}
    `;
export const GetUsersDocument = `
    query GetUsers($query: String!) {
  getUsers(data: {query: $query}) {
    email
    firstname
    lastname
    roles {
      newsroom
      roleType
    }
  }
}
    `;
export const CreateClipsDocument = `
    mutation CreateClips($assetId: Int!, $provider: String!, $cutRanges: [WeakCutRange!]!) {
  createClips(
    data: {assetId: $assetId, provider: $provider, cutRanges: $cutRanges}
  ) {
    ... on CreateClipsSuccessResponse {
      assetId
      originAssetId
    }
    ... on ErrorResponse {
      message
    }
  }
}
    `;
export const TrimAssetDocument = `
    mutation TrimAsset($assetId: Int!, $provider: String!, $cutRanges: [WeakCutRange!]!) {
  trimAsset(data: {assetId: $assetId, provider: $provider, cutRanges: $cutRanges})
}
    `;
export const TranscodeVideoDocument = `
    mutation transcodeVideo($assetId: Int!, $newsroom: String!, $sourceUri: String!, $options: TranscodeVideoOptions) {
  transcodeVideo(
    assetId: $assetId
    newsroom: $newsroom
    sourceUri: $sourceUri
    options: $options
  ) {
    assetId
    requestId
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetAssetHistory: build.query<GetAssetHistoryQuery, GetAssetHistoryQueryVariables>({
      query: (variables) => ({ document: GetAssetHistoryDocument, variables })
    }),
    searchAuthors: build.query<SearchAuthorsQuery, SearchAuthorsQueryVariables>({
      query: (variables) => ({ document: SearchAuthorsDocument, variables })
    }),
    getAuthors: build.query<GetAuthorsQuery, GetAuthorsQueryVariables>({
      query: (variables) => ({ document: GetAuthorsDocument, variables })
    }),
    searchTags: build.query<SearchTagsQuery, SearchTagsQueryVariables>({
      query: (variables) => ({ document: SearchTagsDocument, variables })
    }),
    suggestTags: build.query<SuggestTagsQuery, SuggestTagsQueryVariables>({
      query: (variables) => ({ document: SuggestTagsDocument, variables })
    }),
    listTags: build.query<ListTagsQuery, ListTagsQueryVariables>({
      query: (variables) => ({ document: ListTagsDocument, variables })
    }),
    getStories: build.query<GetStoriesQuery, GetStoriesQueryVariables>({
      query: (variables) => ({ document: GetStoriesDocument, variables })
    }),
    searchStories: build.query<SearchStoriesQuery, SearchStoriesQueryVariables>({
      query: (variables) => ({ document: SearchStoriesDocument, variables })
    }),
    createAssetPreview: build.mutation<CreateAssetPreviewMutation, CreateAssetPreviewMutationVariables>({
      query: (variables) => ({ document: CreateAssetPreviewDocument, variables })
    }),
    uploadAssetPreview: build.mutation<UploadAssetPreviewMutation, UploadAssetPreviewMutationVariables>({
      query: (variables) => ({ document: UploadAssetPreviewDocument, variables })
    }),
    uploadCategoryPreview: build.mutation<UploadCategoryPreviewMutation, UploadCategoryPreviewMutationVariables>({
      query: (variables) => ({ document: UploadCategoryPreviewDocument, variables })
    }),
    getLastAssetIngest: build.query<GetLastAssetIngestQuery, GetLastAssetIngestQueryVariables>({
      query: (variables) => ({ document: GetLastAssetIngestDocument, variables })
    }),
    getLastAssetsIngest: build.query<GetLastAssetsIngestQuery, GetLastAssetsIngestQueryVariables>({
      query: (variables) => ({ document: GetLastAssetsIngestDocument, variables })
    }),
    GetLiveEncoders: build.query<GetLiveEncodersQuery, GetLiveEncodersQueryVariables>({
      query: (variables) => ({ document: GetLiveEncodersDocument, variables })
    }),
    GetMediaLiveInputs: build.query<GetMediaLiveInputsQuery, GetMediaLiveInputsQueryVariables>({
      query: (variables) => ({ document: GetMediaLiveInputsDocument, variables })
    }),
    GetCuttingroomChannels: build.query<GetCuttingroomChannelsQuery, GetCuttingroomChannelsQueryVariables>({
      query: (variables) => ({ document: GetCuttingroomChannelsDocument, variables })
    }),
    LiveArchive: build.query<LiveArchiveQuery, LiveArchiveQueryVariables>({
      query: (variables) => ({ document: LiveArchiveDocument, variables })
    }),
    CreateLiveStream: build.mutation<CreateLiveStreamMutation, CreateLiveStreamMutationVariables>({
      query: (variables) => ({ document: CreateLiveStreamDocument, variables })
    }),
    prepareLiveStream: build.mutation<PrepareLiveStreamMutation, PrepareLiveStreamMutationVariables>({
      query: (variables) => ({ document: PrepareLiveStreamDocument, variables })
    }),
    StartLiveStream: build.mutation<StartLiveStreamMutation, StartLiveStreamMutationVariables>({
      query: (variables) => ({ document: StartLiveStreamDocument, variables })
    }),
    StopLiveStream: build.mutation<StopLiveStreamMutation, StopLiveStreamMutationVariables>({
      query: (variables) => ({ document: StopLiveStreamDocument, variables })
    }),
    UpdateLiveStream: build.mutation<UpdateLiveStreamMutation, UpdateLiveStreamMutationVariables>({
      query: (variables) => ({ document: UpdateLiveStreamDocument, variables })
    }),
    InsertAd: build.mutation<InsertAdMutation, InsertAdMutationVariables>({
      query: (variables) => ({ document: InsertAdDocument, variables })
    }),
    CancelAd: build.mutation<CancelAdMutation, CancelAdMutationVariables>({
      query: (variables) => ({ document: CancelAdDocument, variables })
    }),
    UnpublishLiveAsset: build.mutation<UnpublishLiveAssetMutation, UnpublishLiveAssetMutationVariables>({
      query: (variables) => ({ document: UnpublishLiveAssetDocument, variables })
    }),
    EncoderInputPreview: build.query<EncoderInputPreviewQuery, EncoderInputPreviewQueryVariables>({
      query: (variables) => ({ document: EncoderInputPreviewDocument, variables })
    }),
    getLive: build.query<GetLiveQuery, GetLiveQueryVariables>({
      query: (variables) => ({ document: GetLiveDocument, variables })
    }),
    createRtmpPush: build.mutation<CreateRtmpPushMutation, CreateRtmpPushMutationVariables>({
      query: (variables) => ({ document: CreateRtmpPushDocument, variables })
    }),
    prepareRtmpPush: build.mutation<PrepareRtmpPushMutation, PrepareRtmpPushMutationVariables>({
      query: (variables) => ({ document: PrepareRtmpPushDocument, variables })
    }),
    DuplicateLiveStream: build.mutation<DuplicateLiveStreamMutation, DuplicateLiveStreamMutationVariables>({
      query: (variables) => ({ document: DuplicateLiveStreamDocument, variables })
    }),
    changeAssetRestrictions: build.mutation<ChangeAssetRestrictionsMutation, ChangeAssetRestrictionsMutationVariables>({
      query: (variables) => ({ document: ChangeAssetRestrictionsDocument, variables })
    }),
    uploadSubtitles: build.mutation<UploadSubtitlesMutation, UploadSubtitlesMutationVariables>({
      query: (variables) => ({ document: UploadSubtitlesDocument, variables })
    }),
    streamDuration: build.query<StreamDurationQuery, StreamDurationQueryVariables>({
      query: (variables) => ({ document: StreamDurationDocument, variables })
    }),
    signAssetStreamUrls: build.mutation<SignAssetStreamUrlsMutation, SignAssetStreamUrlsMutationVariables>({
      query: (variables) => ({ document: SignAssetStreamUrlsDocument, variables })
    }),
    GetPlaylists: build.query<GetPlaylistsQuery, GetPlaylistsQueryVariables>({
      query: (variables) => ({ document: GetPlaylistsDocument, variables })
    }),
    CreatePlaylist: build.mutation<CreatePlaylistMutation, CreatePlaylistMutationVariables>({
      query: (variables) => ({ document: CreatePlaylistDocument, variables })
    }),
    UpdatePlaylist: build.mutation<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>({
      query: (variables) => ({ document: UpdatePlaylistDocument, variables })
    }),
    DeletePlaylist: build.mutation<DeletePlaylistMutation, DeletePlaylistMutationVariables>({
      query: (variables) => ({ document: DeletePlaylistDocument, variables })
    }),
    PodmeCategories: build.query<PodmeCategoriesQuery, PodmeCategoriesQueryVariables | void>({
      query: (variables) => ({ document: PodmeCategoriesDocument, variables })
    }),
    AssetPodmeMetadata: build.query<AssetPodmeMetadataQuery, AssetPodmeMetadataQueryVariables>({
      query: (variables) => ({ document: AssetPodmeMetadataDocument, variables })
    }),
    CategoryPodmeMetadata: build.query<CategoryPodmeMetadataQuery, CategoryPodmeMetadataQueryVariables>({
      query: (variables) => ({ document: CategoryPodmeMetadataDocument, variables })
    }),
    ModifyAssetPodmeMetadata: build.mutation<ModifyAssetPodmeMetadataMutation, ModifyAssetPodmeMetadataMutationVariables>({
      query: (variables) => ({ document: ModifyAssetPodmeMetadataDocument, variables })
    }),
    ModifyCategoryPodmeMetadata: build.mutation<ModifyCategoryPodmeMetadataMutation, ModifyCategoryPodmeMetadataMutationVariables>({
      query: (variables) => ({ document: ModifyCategoryPodmeMetadataDocument, variables })
    }),
    SendPushNotification: build.mutation<SendPushNotificationMutation, SendPushNotificationMutationVariables>({
      query: (variables) => ({ document: SendPushNotificationDocument, variables })
    }),
    GetAssetSchedules: build.query<GetAssetSchedulesQuery, GetAssetSchedulesQueryVariables>({
      query: (variables) => ({ document: GetAssetSchedulesDocument, variables })
    }),
    CreateAssetSchedule: build.mutation<CreateAssetScheduleMutation, CreateAssetScheduleMutationVariables>({
      query: (variables) => ({ document: CreateAssetScheduleDocument, variables })
    }),
    UpdateAssetSchedule: build.mutation<UpdateAssetScheduleMutation, UpdateAssetScheduleMutationVariables>({
      query: (variables) => ({ document: UpdateAssetScheduleDocument, variables })
    }),
    DeleteAssetSchedule: build.mutation<DeleteAssetScheduleMutation, DeleteAssetScheduleMutationVariables>({
      query: (variables) => ({ document: DeleteAssetScheduleDocument, variables })
    }),
    GetNotificationSchedules: build.query<GetNotificationSchedulesQuery, GetNotificationSchedulesQueryVariables>({
      query: (variables) => ({ document: GetNotificationSchedulesDocument, variables })
    }),
    CreateNotificationSchedule: build.mutation<CreateNotificationScheduleMutation, CreateNotificationScheduleMutationVariables>({
      query: (variables) => ({ document: CreateNotificationScheduleDocument, variables })
    }),
    UpdateNotificationSchedule: build.mutation<UpdateNotificationScheduleMutation, UpdateNotificationScheduleMutationVariables>({
      query: (variables) => ({ document: UpdateNotificationScheduleDocument, variables })
    }),
    DeleteNotificationSchedule: build.mutation<DeleteNotificationScheduleMutation, DeleteNotificationScheduleMutationVariables>({
      query: (variables) => ({ document: DeleteNotificationScheduleDocument, variables })
    }),
    GetEngagementStatsApiKey: build.query<GetEngagementStatsApiKeyQuery, GetEngagementStatsApiKeyQueryVariables>({
      query: (variables) => ({ document: GetEngagementStatsApiKeyDocument, variables })
    }),
    GenerateSubtitlesForAsset: build.mutation<GenerateSubtitlesForAssetMutation, GenerateSubtitlesForAssetMutationVariables>({
      query: (variables) => ({ document: GenerateSubtitlesForAssetDocument, variables })
    }),
    getDurationFromUrl: build.query<GetDurationFromUrlQuery, GetDurationFromUrlQueryVariables>({
      query: (variables) => ({ document: GetDurationFromUrlDocument, variables })
    }),
    ConvertVideo: build.mutation<ConvertVideoMutation, ConvertVideoMutationVariables>({
      query: (variables) => ({ document: ConvertVideoDocument, variables })
    }),
    PrepareLiveArchive: build.mutation<PrepareLiveArchiveMutation, PrepareLiveArchiveMutationVariables>({
      query: (variables) => ({ document: PrepareLiveArchiveDocument, variables })
    }),
    CropLiveArchive: build.mutation<CropLiveArchiveMutation, CropLiveArchiveMutationVariables>({
      query: (variables) => ({ document: CropLiveArchiveDocument, variables })
    }),
    LiveArchiveExpiration: build.query<LiveArchiveExpirationQuery, LiveArchiveExpirationQueryVariables>({
      query: (variables) => ({ document: LiveArchiveExpirationDocument, variables })
    }),
    CreateUser: build.mutation<CreateUserMutation, CreateUserMutationVariables>({
      query: (variables) => ({ document: CreateUserDocument, variables })
    }),
    UpdateUser: build.mutation<UpdateUserMutation, UpdateUserMutationVariables>({
      query: (variables) => ({ document: UpdateUserDocument, variables })
    }),
    GetUsers: build.query<GetUsersQuery, GetUsersQueryVariables>({
      query: (variables) => ({ document: GetUsersDocument, variables })
    }),
    CreateClips: build.mutation<CreateClipsMutation, CreateClipsMutationVariables>({
      query: (variables) => ({ document: CreateClipsDocument, variables })
    }),
    TrimAsset: build.mutation<TrimAssetMutation, TrimAssetMutationVariables>({
      query: (variables) => ({ document: TrimAssetDocument, variables })
    }),
    transcodeVideo: build.mutation<TranscodeVideoMutation, TranscodeVideoMutationVariables>({
      query: (variables) => ({ document: TranscodeVideoDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetAssetHistoryQuery, useLazyGetAssetHistoryQuery, useSearchAuthorsQuery, useLazySearchAuthorsQuery, useGetAuthorsQuery, useLazyGetAuthorsQuery, useSearchTagsQuery, useLazySearchTagsQuery, useSuggestTagsQuery, useLazySuggestTagsQuery, useListTagsQuery, useLazyListTagsQuery, useGetStoriesQuery, useLazyGetStoriesQuery, useSearchStoriesQuery, useLazySearchStoriesQuery, useCreateAssetPreviewMutation, useUploadAssetPreviewMutation, useUploadCategoryPreviewMutation, useGetLastAssetIngestQuery, useLazyGetLastAssetIngestQuery, useGetLastAssetsIngestQuery, useLazyGetLastAssetsIngestQuery, useGetLiveEncodersQuery, useLazyGetLiveEncodersQuery, useGetMediaLiveInputsQuery, useLazyGetMediaLiveInputsQuery, useGetCuttingroomChannelsQuery, useLazyGetCuttingroomChannelsQuery, useLiveArchiveQuery, useLazyLiveArchiveQuery, useCreateLiveStreamMutation, usePrepareLiveStreamMutation, useStartLiveStreamMutation, useStopLiveStreamMutation, useUpdateLiveStreamMutation, useInsertAdMutation, useCancelAdMutation, useUnpublishLiveAssetMutation, useEncoderInputPreviewQuery, useLazyEncoderInputPreviewQuery, useGetLiveQuery, useLazyGetLiveQuery, useCreateRtmpPushMutation, usePrepareRtmpPushMutation, useDuplicateLiveStreamMutation, useChangeAssetRestrictionsMutation, useUploadSubtitlesMutation, useStreamDurationQuery, useLazyStreamDurationQuery, useSignAssetStreamUrlsMutation, useGetPlaylistsQuery, useLazyGetPlaylistsQuery, useCreatePlaylistMutation, useUpdatePlaylistMutation, useDeletePlaylistMutation, usePodmeCategoriesQuery, useLazyPodmeCategoriesQuery, useAssetPodmeMetadataQuery, useLazyAssetPodmeMetadataQuery, useCategoryPodmeMetadataQuery, useLazyCategoryPodmeMetadataQuery, useModifyAssetPodmeMetadataMutation, useModifyCategoryPodmeMetadataMutation, useSendPushNotificationMutation, useGetAssetSchedulesQuery, useLazyGetAssetSchedulesQuery, useCreateAssetScheduleMutation, useUpdateAssetScheduleMutation, useDeleteAssetScheduleMutation, useGetNotificationSchedulesQuery, useLazyGetNotificationSchedulesQuery, useCreateNotificationScheduleMutation, useUpdateNotificationScheduleMutation, useDeleteNotificationScheduleMutation, useGetEngagementStatsApiKeyQuery, useLazyGetEngagementStatsApiKeyQuery, useGenerateSubtitlesForAssetMutation, useGetDurationFromUrlQuery, useLazyGetDurationFromUrlQuery, useConvertVideoMutation, usePrepareLiveArchiveMutation, useCropLiveArchiveMutation, useLiveArchiveExpirationQuery, useLazyLiveArchiveExpirationQuery, useCreateUserMutation, useUpdateUserMutation, useGetUsersQuery, useLazyGetUsersQuery, useCreateClipsMutation, useTrimAssetMutation, useTranscodeVideoMutation } = injectedRtkApi;

